import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import {
    Alert,
    Badge,
    Button,
    Card,
    Col,
    Divider,
    Row,
    Select,
    Space,
    Spin,
    Statistic,
    Tag,
    Typography,
} from "antd";

import {
    CameraOutlined,
    CheckCircleFilled,
    CloseCircleFilled,
    SafetyCertificateOutlined,
    ScanOutlined,
    ReloadOutlined,
    WifiOutlined,
    DesktopOutlined,
    WarningFilled,
    SwapOutlined,
    SoundOutlined,
    MobileOutlined,
} from "@ant-design/icons";


import {
    BrowserQRCodeReader,
} from "@zxing/browser";

import Swal from "sweetalert2";

import companyLogo from "./poluschoologoart.png";

import api from "../../api/api";
import { useAcademicYear } from "../../AcademicYearContext";



import SUCCESS_AUDIO from "./audio/sucess.mp3";
import ERROR_AUDIO from "./audio/error.wav";



const {
    Title,
    Text,
} = Typography;


/* =========================================================
   API ENDPOINTS
   ========================================================= */

const DEVICE_ENDPOINT =
    "/api/smart-teacher-attendance/devices/";

const SCAN_ENDPOINT =
    "/api/smart-teacher-attendance/scan/";

const QR_READER_ID =
    "teacher-attendance-qr-reader";


/* =========================================================
   INITIAL RESULT
   ========================================================= */

const INITIAL_RESULT = {
    type: null,
    action: null,
    message: null,
    teacher: null,
    card: null,
    time: null,
    gate: null,
    device: null,
    attendance: null,
};


/* =========================================================
   SWEETALERT COLORS
   ========================================================= */

const SWEET_SUCCESS =
    "#52c41a";

const SWEET_ERROR =
    "#ff4d4f";

const SWEET_WARNING =
    "#fa8c16";

const PRIMARY_ORANGE =
    "#f97316";


/* =========================================================
   COMPONENT
   ========================================================= */

const TeacherAttendanceScanner = () => {
const {
    activeYear,
    selectedYear,
    academicYears,
} = useAcademicYear();   

      /* =====================================================
       STATE
       ===================================================== */

    const [scannerRunning, setScannerRunning] =
        useState(false);

    const [initializingScanner, setInitializingScanner] =
        useState(false);

    const [processingScan, setProcessingScan] =
        useState(false);

    const [loadingDevice, setLoadingDevice] =
        useState(true);

    const [result, setResult] =
        useState(INITIAL_RESULT);

    const [error, setError] =
        useState(null);

    const [cameraError, setCameraError] =
        useState(null);

    const [deviceError, setDeviceError] =
        useState(null);

    const [scanCount, setScanCount] =
        useState(0);

    const [duplicateCount, setDuplicateCount] =
        useState(0);

    const [rejectedCount, setRejectedCount] =
        useState(0);

    const [deviceOnline, setDeviceOnline] =
        useState(
            typeof navigator !== "undefined"
                ? navigator.onLine
                : true
        );

    const [lastScanAt, setLastScanAt] =
        useState(null);

    const [scannerDevice, setScannerDevice] =
        useState(null);

    const [cameraList, setCameraList] =
        useState([]);

    const [selectedCameraId, setSelectedCameraId] =
        useState(null);

    const [cameraPermissionGranted, setCameraPermissionGranted] =
        useState(false);

    
    const mountedRef = useRef(false);
const successAudioRef = useRef(null);
const errorAudioRef = useRef(null);
const audioUnlockedRef = useRef(false);
const resultTimeoutRef = useRef(null);
const processingScanRef = useRef(false);
const lastScannedTokenRef = useRef(null);
const lastScannedTimeRef = useRef(0);


    /* =====================================================
       REFS
       ===================================================== */

const qrReaderRef =
    useRef(null);


    const scannerRef =
    useRef(null);

const scannerControlsRef =
    useRef(null);

const mediaStreamRef =
    useRef(null);

const videoRef =
    useRef(null);

const startingScannerRef =
    useRef(false);

const selectedCameraRef =
    useRef(null);


const selectedFacingModeRef =
    useRef("environment");


   /* =====================================================
       CAMERA LABEL HELPERS
       ===================================================== */

    // const isBackCamera =
    //     useCallback(
    //         (camera) => {

    //             if (!camera) {
    //                 return false;
    //             }

    //             const label =
    //                 String(
    //                     camera.label || ""
    //                 ).toLowerCase();

    //             return (
    //                 label.includes("back") ||
    //                 label.includes("rear") ||
    //                 label.includes("environment") ||
    //                 label.includes("trás") ||
    //                 label.includes("tras") ||
    //                 label.includes("dorsal") ||
    //                 label.includes("principal") ||
    //                 label.includes("camera 0")
    //             );

    //         },
    //         []
    //     );




    // const isFrontCamera =
    //     useCallback(
    //         (camera) => {

    //             if (!camera) {
    //                 return false;
    //             }

    //             const label =
    //                 String(
    //                     camera.label || ""
    //                 ).toLowerCase();

    //             return (
    //                 label.includes("front") ||
    //                 label.includes("user") ||
    //                 label.includes("facetime") ||
    //                 label.includes("selfie") ||
    //                 label.includes("face")
    //             );

    //         },
    //         []
    //     );


    const isBackCamera =
    useCallback(
        camera => {

            if (!camera) {
                return false;
            }


            const label =
                String(
                    camera.label || ""
                ).toLowerCase();


            return (
                label.includes("back") ||
                label.includes("rear") ||
                label.includes("environment") ||
                label.includes("dorsal") ||
                label.includes("principal") ||
                label.includes("trás") ||
                label.includes("tras")
            );

        },
        []
    );


const isFrontCamera =
    useCallback(
        camera => {

            if (!camera) {
                return false;
            }


            const label =
                String(
                    camera.label || ""
                ).toLowerCase();


            return (
                label.includes("front") ||
                label.includes("user") ||
                label.includes("selfie") ||
                label.includes("facetime") ||
                label.includes("face")
            );

        },
        []
    );


    /* =====================================================
       MOUNT
       ===================================================== */

// useEffect(() => {

//     mountedRef.current = true;

//     return () => {

//         mountedRef.current = false;

//         if (resultTimeoutRef.current) {

//             clearTimeout(
//                 resultTimeoutRef.current
//             );

//             resultTimeoutRef.current = null;
//         }

//         try {

//             if (scannerRef.current) {

//                 scannerRef.current.reset();

//             }

//         } catch (error) {

//             console.warn(
//                 "Scanner cleanup warning:",
//                 error
//             );

//         }

//         try {

//             const video =
//                 videoRef.current;

//             if (video) {

//                 const stream =
//                     video.srcObject;

//                 if (stream) {

//                     stream
//                         .getTracks()
//                         .forEach(
//                             track => {
//                                 try {
//                                     track.stop();
//                                 } catch (
//                                     trackError
//                                 ) {}
//                             }
//                         );
//                 }

//                 video.pause();

//                 video.srcObject = null;
//             }

//         } catch (error) {

//             console.warn(
//                 "Video cleanup warning:",
//                 error
//             );
//         }

//         scannerRef.current = null;

//     };

// }, []);


useEffect(
    () => {

        mountedRef.current =
            true;


        return () => {

            mountedRef.current =
                false;


            /*
             * Stop scanner.
             */

            try {

                if (
                    scannerControlsRef.current
                ) {

                    scannerControlsRef.current.stop();

                }

            } catch (
                error
            ) {

                console.warn(
                    "ZXing controls cleanup warning:",
                    error
                );

            }


            /*
             * Stop ZXing reader.
             */

            try {

                if (
                    scannerRef.current
                ) {

                    scannerRef.current.reset();

                }

            } catch (
                error
            ) {

                console.warn(
                    "ZXing reader cleanup warning:",
                    error
                );

            }


            /*
             * Stop actual MediaStream.
             */

            try {

                if (
                    mediaStreamRef.current
                ) {

                    mediaStreamRef.current
                        .getTracks()
                        .forEach(
                            track => {

                                try {

                                    track.stop();

                                } catch (
                                    trackError
                                ) {}

                            }
                        );

                }

            } catch (
                error
            ) {}


            /*
             * Clear video.
             */

            try {

                if (
                    videoRef.current
                ) {

                    videoRef.current.pause();

                    videoRef.current.srcObject =
                        null;

                }

            } catch (
                error
            ) {}


            scannerControlsRef.current =
                null;

            scannerRef.current =
                null;

            mediaStreamRef.current =
                null;


            /*
             * Clear timeout.
             */

            if (
                resultTimeoutRef.current
            ) {

                clearTimeout(
                    resultTimeoutRef.current
                );

                resultTimeoutRef.current =
                    null;

            }

        };

    },
    []
);

    /* =====================================================
       ONLINE / OFFLINE
       ===================================================== */

    useEffect(() => {

        const handleOnline = () => {
            setDeviceOnline(true);
        };

        const handleOffline = () => {
            setDeviceOnline(false);
        };

        window.addEventListener(
            "online",
            handleOnline
        );

        window.addEventListener(
            "offline",
            handleOffline
        );

        return () => {

            window.removeEventListener(
                "online",
                handleOnline
            );

            window.removeEventListener(
                "offline",
                handleOffline
            );

        };

    }, []);


    /* =====================================================
       INITIALIZE AUDIO
       ===================================================== */

    useEffect(() => {

        try {

            successAudioRef.current =
                new Audio(
                    SUCCESS_AUDIO
                );

            successAudioRef.current.preload =
                "auto";

            successAudioRef.current.volume =
                1.0;


            errorAudioRef.current =
                new Audio(
                    ERROR_AUDIO
                );

            errorAudioRef.current.preload =
                "auto";

            errorAudioRef.current.volume =
                1.0;


        } catch (audioError) {

            console.error(
                "Audio initialization error:",
                audioError
            );

        }


        return () => {

            try {

                if (
                    successAudioRef.current
                ) {

                    successAudioRef.current.pause();

                    successAudioRef.current.src =
                        "";

                }

            } catch (cleanupError) {}


            try {

                if (
                    errorAudioRef.current
                ) {

                    errorAudioRef.current.pause();

                    errorAudioRef.current.src =
                        "";

                }

            } catch (cleanupError) {}

        };

    }, []);




    const unlockAudio =
        useCallback(
            async () => {

                try {

                    const audio =
                        successAudioRef.current;

                    if (!audio) {
                        return;
                    }


                    audio.muted = true;

                    audio.currentTime =
                        0;


                    const playPromise =
                        audio.play();


                    if (
                        playPromise &&
                        typeof playPromise.then ===
                            "function"
                    ) {

                        await playPromise;

                    }


                    audio.pause();

                    audio.currentTime =
                        0;

                    audio.muted = false;

                    audioUnlockedRef.current =
                        true;


                } catch (audioError) {

                    /*
                     * Some browsers still block this.
                     * The scanner continues working.
                     */

                    console.warn(
                        "Audio could not be unlocked:",
                        audioError
                    );

                    audioUnlockedRef.current =
                        false;

                }

            },
            []
        );


    /* =====================================================
       PLAY SUCCESS SOUND
       ===================================================== */

    const playSuccessSound =
        useCallback(
            async () => {

                try {

                    const audio =
                        successAudioRef.current;

                    if (!audio) {
                        return;
                    }


                    audio.pause();

                    audio.currentTime =
                        0;

                    audio.volume =
                        1.0;

                    audio.muted =
                        false;


                    const playPromise =
                        audio.play();


                    if (
                        playPromise &&
                        typeof playPromise.then ===
                            "function"
                    ) {

                        await playPromise;

                    }

                } catch (audioError) {

                    console.warn(
                        "Success sound could not play:",
                        audioError
                    );

                }

            },
            []
        );


    /* =====================================================
       PLAY ERROR SOUND
       ===================================================== */

    const playErrorSound =
        useCallback(
            async () => {

                try {

                    const audio =
                        errorAudioRef.current;

                    if (!audio) {
                        return;
                    }


                    audio.pause();

                    audio.currentTime =
                        0;

                    audio.volume =
                        1.0;

                    audio.muted =
                        false;


                    const playPromise =
                        audio.play();


                    if (
                        playPromise &&
                        typeof playPromise.then ===
                            "function"
                    ) {

                        await playPromise;

                    }

                } catch (audioError) {

                    console.warn(
                        "Error sound could not play:",
                        audioError
                    );

                }

            },
            []
        );


    /* =====================================================
       SWEETALERT SUCCESS
       ===================================================== */

    const showSuccessAlert =
        useCallback(
            ({
                title,
                message,
                teacherName,
                action,
                time,
                gate,
            }) => {

                const actionText =
                    action === "check_out"
                        ? "CHECK-OUT SUCCESSFUL"
                        : "CHECK-IN SUCCESSFUL";


                Swal.fire({

                    icon:
                        "success",

                    title:
                        title ||
                        actionText,

                    html: `

                        <div
                            style="
                                margin-top: 8px;
                            "
                        >

                            ${
                                teacherName
                                    ? `
                                        <div
                                            style="
                                                font-size: 24px;
                                                font-weight: 800;
                                                color: #111827;
                                                margin-bottom: 10px;
                                            "
                                        >
                                            ${teacherName}
                                        </div>
                                    `
                                    : ""
                            }

                            <div
                                style="
                                    font-size: 16px;
                                    color: #374151;
                                    font-weight: 600;
                                    margin-bottom: 14px;
                                "
                            >
                                ${message || ""}
                            </div>

                            <div
                                style="
                                    background: #f6ffed;
                                    border: 1px solid #b7eb8f;
                                    border-radius: 10px;
                                    padding: 12px;
                                    color: #237804;
                                    font-weight: 600;
                                "
                            >
                                <div>
                                    Time:
                                    ${
                                        time || "--"
                                    }
                                </div>

                                <div>
                                    Gate:
                                    ${
                                        gate || "--"
                                    }
                                </div>

                            </div>

                        </div>

                    `,

                    confirmButtonText:
                        "OK",

                    confirmButtonColor:
                        PRIMARY_ORANGE,

                    allowOutsideClick:
                        true,

                    timer:
                        5000,

                    timerProgressBar:
                        true,

                });

            },
            []
        );


    /* =====================================================
       SWEETALERT DUPLICATE
       ===================================================== */

    const showDuplicateAlert =
        useCallback(
            ({
                message,
                teacherName,
                time,
                gate,
            }) => {

                Swal.fire({

                    icon:
                        "warning",

                    title:
                        "DUPLICATE SCAN",

                    html: `

                        <div
                            style="
                                margin-top: 8px;
                            "
                        >

                            ${
                                teacherName
                                    ? `
                                        <div
                                            style="
                                                font-size: 24px;
                                                font-weight: 800;
                                                color: #111827;
                                                margin-bottom: 10px;
                                            "
                                        >
                                            ${teacherName}
                                        </div>
                                    `
                                    : ""
                            }

                            <div
                                style="
                                    font-size: 16px;
                                    color: #374151;
                                    font-weight: 600;
                                    margin-bottom: 14px;
                                "
                            >
                                ${message || ""}
                            </div>

                            <div
                                style="
                                    background: #fff7e6;
                                    border: 1px solid #ffd591;
                                    border-radius: 10px;
                                    padding: 12px;
                                    color: #ad4e00;
                                    font-weight: 600;
                                "
                            >

                                <div>
                                    Time:
                                    ${
                                        time || "--"
                                    }
                                </div>

                                <div>
                                    Gate:
                                    ${
                                        gate || "--"
                                    }
                                </div>

                            </div>

                        </div>

                    `,

                    confirmButtonText:
                        "OK",

                    confirmButtonColor:
                        PRIMARY_ORANGE,

                    timer:
                        5000,

                    timerProgressBar:
                        true,

                });

            },
            []
        );


    /* =====================================================
       SWEETALERT ERROR
       ===================================================== */

    const showErrorAlert =
        useCallback(
            ({
                message,
                teacherName,
                time,
                gate,
            }) => {

                Swal.fire({

                    icon:
                        "error",

                    title:
                        "SCAN REJECTED",

                    html: `

                        <div
                            style="
                                margin-top: 8px;
                            "
                        >

                            ${
                                teacherName
                                    ? `
                                        <div
                                            style="
                                                font-size: 22px;
                                                font-weight: 800;
                                                color: #111827;
                                                margin-bottom: 10px;
                                            "
                                        >
                                            ${teacherName}
                                        </div>
                                    `
                                    : ""
                            }

                            <div
                                style="
                                    font-size: 16px;
                                    color: #374151;
                                    font-weight: 600;
                                    margin-bottom: 14px;
                                "
                            >
                                ${message || "Unable to process this QR scan."}
                            </div>

                            <div
                                style="
                                    background: #fff1f0;
                                    border: 1px solid #ffa39e;
                                    border-radius: 10px;
                                    padding: 12px;
                                    color: #a8071a;
                                    font-weight: 600;
                                "
                            >

                                <div>
                                    Time:
                                    ${
                                        time || "--"
                                    }
                                </div>

                                <div>
                                    Gate:
                                    ${
                                        gate || "--"
                                    }
                                </div>

                            </div>

                        </div>

                    `,

                    confirmButtonText:
                        "OK",

                    confirmButtonColor:
                        PRIMARY_ORANGE,

                    allowOutsideClick:
                        true,

                });

            },
            []
        );


    /* =====================================================
       API ERROR MESSAGE
       ===================================================== */

    const getApiErrorMessage =
        useCallback(
            (apiError, fallback) => {

                const data =
                    apiError?.response?.data;

                if (!data) {
                    return fallback;
                }

                if (typeof data === "string") {
                    return data;
                }

                if (
                    Array.isArray(
                        data.non_field_errors
                    )
                ) {

                    return (
                        data.non_field_errors[0] ||
                        fallback
                    );

                }

                return (
                    data.detail ||
                    data.message ||
                    data.error ||
                    fallback
                );

            },
            []
        );


    /* =====================================================
       NORMALIZE ACTION
       ===================================================== */

    const normalizeAction =
        useCallback(
            (rawAction) => {

                if (!rawAction) {
                    return null;
                }

                const action =
                    String(rawAction)
                        .trim()
                        .toUpperCase()
                        .replace(/-/g, "_")
                        .replace(/ /g, "_");


                if (
                    action === "CHECK_IN" ||
                    action === "CHECKIN"
                ) {

                    return "check_in";

                }


                if (
                    action === "CHECK_OUT" ||
                    action === "CHECKOUT"
                ) {

                    return "check_out";

                }


                if (
                    action === "DUPLICATE" ||
                    action === "DUPLICATE_SCAN" ||
                    action === "ALREADY_COMPLETED" ||
                    action === "ALREADY_CHECKED_OUT"
                ) {

                    return "duplicate";

                }


                if (
                    action === "REJECTED" ||
                    action === "REJECT" ||
                    action === "FAILED" ||
                    action === "INVALID_QR" ||
                    action === "INVALID_DEVICE" ||
                    action === "CARD_INACTIVE" ||
                    action === "NO_ACTIVE_ACADEMIC_YEAR" ||
                    action === "ACADEMIC_YEAR_MISMATCH"
                ) {

                    return "rejected";

                }


                return action
                    ? action.toLowerCase()
                    : null;

            },
            []
        );


    /* =====================================================
       RESULT TYPE
       ===================================================== */

    const getResultType =
        useCallback(
            (data, action) => {

                if (
                    action === "rejected"
                ) {

                    return "error";

                }


                if (
                    action === "duplicate"
                ) {

                    return "duplicate";

                }


                if (
                    action === "check_in" ||
                    action === "check_out"
                ) {

                    return "success";

                }


                if (
                    data?.success === true
                ) {

                    return "success";

                }


                return "error";

            },
            []
        );


    /* =====================================================
       LOAD REGISTERED DEVICE
       ===================================================== */

    const loadScannerDevice =
        useCallback(
            async () => {

                if (!mountedRef.current) {
                    return;
                }

                setLoadingDevice(true);
                setDeviceError(null);

                try {

                    const response =
                        await api.get(
                            DEVICE_ENDPOINT,
                            {
                                timeout:
                                    15000,
                            }
                        );


                    const responseData =
                        response?.data;


                    let devices = [];


                    if (
                        Array.isArray(
                            responseData
                        )
                    ) {

                        devices =
                            responseData;

                    } else if (
                        Array.isArray(
                            responseData?.results
                        )
                    ) {

                        devices =
                            responseData.results;

                    }


                    const activeDevices =
                        devices.filter(
                            device =>
                                device &&
                                device.is_active !== false
                        );


                    let selectedDevice =
                        activeDevices[0] ||
                        null;


                    if (
                        responseData?.current_device
                    ) {

                        selectedDevice =
                            responseData.current_device;

                    }


                    if (
                        responseData?.device
                    ) {

                        selectedDevice =
                            responseData.device;

                    }


                    if (!selectedDevice) {

                        setScannerDevice(
                            null
                        );

                        setDeviceError(
                            "This scanner device is not registered. Please ask an administrator to register this phone, tablet, laptop, or computer under Scanner Devices."
                        );

                        return;

                    }


                    setScannerDevice(
                        selectedDevice
                    );


                } catch (deviceLoadError) {

                    console.error(
                        "Failed to load scanner device:",
                        deviceLoadError
                    );


                    const status =
                        deviceLoadError?.response?.status;


                    if (
                        status === 401 ||
                        status === 403
                    ) {

                        setDeviceError(
                            "You are not authorized to access the registered scanner device."
                        );

                    } else {

                        setDeviceError(
                            getApiErrorMessage(
                                deviceLoadError,
                                "Unable to load the registered scanner device."
                            )
                        );

                    }


                    setScannerDevice(
                        null
                    );


                } finally {

                    if (
                        mountedRef.current
                    ) {

                        setLoadingDevice(
                            false
                        );

                    }

                }

            },
            [
                getApiErrorMessage,
            ]
        );


    /* =====================================================
       LOAD CAMERA LIST
       ===================================================== */



const loadCameraList =
    useCallback(
        async () => {

            try {

                if (
                    !navigator.mediaDevices ||
                    !navigator.mediaDevices.enumerateDevices
                ) {

                    throw new Error(
                        "This browser does not support camera detection."
                    );

                }


                const devices =
                    await navigator.mediaDevices.enumerateDevices();


                const cameras =
                    devices.filter(
                        device =>
                            device.kind ===
                            "videoinput"
                    );


                setCameraList(
                    cameras
                );


                /*
                 * Keep current camera if it still exists.
                 */

                const currentCamera =
                    selectedCameraRef.current;


                if (
                    currentCamera &&
                    cameras.some(
                        camera =>
                            camera.deviceId ===
                            currentCamera
                    )
                ) {

                    setSelectedCameraId(
                        currentCamera
                    );

                    return cameras;

                }


                /*
                 * Prefer a camera identified as rear.
                 */

                const rearCamera =
                    cameras.find(
                        camera =>
                            isBackCamera(
                                camera
                            )
                    );


                if (
                    rearCamera
                ) {

                    selectedCameraRef.current =
                        rearCamera.deviceId;

                    setSelectedCameraId(
                        rearCamera.deviceId
                    );

                } else if (
                    cameras.length > 0
                ) {

                    /*
                     * Do not assume front/back.
                     *
                     * Simply use first available.
                     */

                    selectedCameraRef.current =
                        cameras[0].deviceId;

                    setSelectedCameraId(
                        cameras[0].deviceId
                    );

                }


                return cameras;

            } catch (
                cameraError
            ) {

                console.error(
                    "Unable to enumerate cameras:",
                    cameraError
                );


                setCameraList(
                    []
                );


                return [];

            }

        },
        [
            isBackCamera,
        ]
    );


    /* =====================================================
       INITIAL LOAD
       ===================================================== */

    useEffect(() => {

        loadScannerDevice();
        loadCameraList();

    }, [
        loadScannerDevice,
        loadCameraList,
    ]);


    /* =====================================================
       STOP SCANNER
       ===================================================== */




    /* =====================================================
       CLEANUP
       ===================================================== */

    useEffect(() => {

        return () => {

            if (
                resultTimeoutRef.current
            ) {

                clearTimeout(
                    resultTimeoutRef.current
                );

            }


            const currentScanner =
                scannerRef.current;


            if (!currentScanner) {
                return;
            }


            try {

                if (
                    currentScanner.isScanning
                ) {

                    currentScanner
                        .stop()
                        .catch(() => {});

                }

            } catch (cleanupError) {

                console.warn(
                    "Scanner cleanup error:",
                    cleanupError
                );

            }

        };

    }, []);


    /* =====================================================
       CLEAR RESULT
       ===================================================== */

    const scheduleResultClear =
        useCallback(
            (delay = 5000) => {

                if (
                    resultTimeoutRef.current
                ) {

                    clearTimeout(
                        resultTimeoutRef.current
                    );

                }


                resultTimeoutRef.current =
                    setTimeout(
                        () => {

                            if (
                                mountedRef.current
                            ) {

                                setResult(
                                    INITIAL_RESULT
                                );

                                setError(
                                    null
                                );

                            }

                        },
                        delay
                    );

            },
            []
        );


    /* =====================================================
       FORMAT TIME
       ===================================================== */

    const formatTime =
        useCallback(
            (dateValue) => {

                if (!dateValue) {
                    return "--";
                }


                const date =
                    new Date(dateValue);


                if (
                    Number.isNaN(
                        date.getTime()
                    )
                ) {

                    return "--";

                }


                return date.toLocaleTimeString(
                    [],
                    {
                        hour:
                            "2-digit",

                        minute:
                            "2-digit",

                        second:
                            "2-digit",
                    }
                );

            },
            []
        );


    /* =====================================================
       TEACHER NAME
       ===================================================== */

    const getTeacherName =
        useCallback(
            (teacher) => {

                if (!teacher) {
                    return null;
                }


                return (
                    teacher.full_name ||
                    teacher.name ||
                    teacher.teacher_name ||
                    [
                        teacher.first_name,
                        teacher.last_name,
                    ]
                        .filter(Boolean)
                        .join(" ") ||
                    null
                );

            },
            []
        );


    /* =====================================================
       PROCESS ATTENDANCE SCAN
       ===================================================== */



const processAttendanceScan =
    useCallback(
        async (qrToken) => {

            /*
             * =====================================================
             * PREVENT DOUBLE PROCESSING
             * =====================================================
             */

            if (
                processingScanRef.current
            ) {

                return;

            }


            /*
             * =====================================================
             * VALIDATE QR TOKEN
             * =====================================================
             */

            if (
                !qrToken
            ) {

                return;

            }


            /*
             * =====================================================
             * ACTIVE ACADEMIC YEAR
             * =====================================================
             */

    


            /*
             * =====================================================
             * DEVICE ONLINE
             * =====================================================
             */

            if (
                !deviceOnline
            ) {

                const message =
                    "The scanner device is offline.";

                setError(
                    message
                );

                await playErrorSound();

                showErrorAlert({
                    message,
                });

                return;

            }


            /*
             * =====================================================
             * DEVICE REGISTRATION
             * =====================================================
             */

            if (
                !scannerDevice ||
                !scannerDevice.device_id
            ) {

                const message =
                    "This scanner device is not registered.";

                setError(
                    message
                );

                await playErrorSound();

                showErrorAlert({
                    message,
                });

                return;

            }


            /*
             * =====================================================
             * DEVICE ACTIVE
             * =====================================================
             */

            if (
                scannerDevice.is_active === false
            ) {

                const message =
                    "This scanner device has been deactivated.";

                setError(
                    message
                );

                await playErrorSound();

                showErrorAlert({
                    message,
                });

                return;

            }


            /*
             * =====================================================
             * LOCK PROCESSING
             * =====================================================
             */

            processingScanRef.current =
                true;

            setProcessingScan(
                true
            );

            setError(
                null
            );


            try {

                /*
                 * =================================================
                 * INITIAL SCAN PAYLOAD
                 * =================================================
                 */

                const payload = {

                    qr_token:
                        qrToken,

                    device_id:
                        scannerDevice.device_id,

                    confirm_checkout:
                        false,

                };


                /*
                 * =================================================
                 * INITIAL SCAN REQUEST
                 * =================================================
                 */

                const response =
                    await api.post(
                        SCAN_ENDPOINT,
                        payload,
                        {
                            timeout:
                                15000,

                            headers: {
                                "Content-Type":
                                    "application/json",
                            },
                        }
                    );


                const data =
                    response?.data ||
                    {};


                /*
                 * =================================================
                 * NORMALIZE ACTION
                 * =================================================
                 */

                const action =
                    normalizeAction(
                        data.action ||
                        data.attendance_action
                    );


                /*
                 * =================================================
                 * RESULT TYPE
                 * =================================================
                 */

                const resultType =
                    getResultType(
                        data,
                        action
                    );


                /*
                 * =================================================
                 * TEACHER
                 * =================================================
                 */

                const teacher =
                    data.teacher ||
                    null;


                /*
                 * =================================================
                 * ATTENDANCE
                 * =================================================
                 */

                const attendance =
                    data.attendance ||
                    null;


                /*
                 * =================================================
                 * TEACHER NAME
                 * =================================================
                 */

                const teacherName =
                    getTeacherName(
                        teacher
                    );


                /*
                 * =================================================
                 * MESSAGE
                 * =================================================
                 */

                const message =
                    data.message ||
                    (
                        action ===
                        "check_in"

                            ? "Teacher checked in successfully."

                            : action ===
                              "check_out"

                                ? "Teacher checked out successfully."

                                : action ===
                                  "checkout_confirmation_required"

                                    ? "Checkout confirmation is required."

                                    : action ===
                                      "duplicate"

                                        ? "Teacher attendance has already been completed for today."

                                        : action ===
                                          "rejected"

                                            ? "This QR scan was rejected."

                                            : "Unable to process this QR scan."
                    );


                /*
                 * =================================================
                 * SCAN TIME
                 * =================================================
                 */

                const scanTime =
                    data.timestamp ||
                    data.scanned_at ||
                    new Date().toISOString();


                /*
                 * =================================================
                 * GATE
                 * =================================================
                 */

                const gate =
                    data.gate ||
                    data.gate_name ||
                    scannerDevice.gate_name ||
                    null;


                /*
                 * =================================================
                 * DEVICE
                 * =================================================
                 */

                const responseDevice =
                    data.device ||
                    scannerDevice ||
                    null;


                /*
                 * =====================================================
                 * CHECKOUT CONFIRMATION
                 * =====================================================
                 *
                 * IMPORTANT:
                 *
                 * The first request only asks for confirmation.
                 *
                 * DO NOT play an error sound here.
                 *
                 * This is NOT an error.
                 *
                 * =====================================================
                 */

                if (
                    action ===
                    "checkout_confirmation_required"
                ) {

                    /*
                     * -------------------------------------------------
                     * DO NOT CALL playErrorSound()
                     * -------------------------------------------------
                     *
                     * Checkout confirmation is a normal workflow.
                     *
                     */


                    /*
                     * -------------------------------------------------
                     * SAFELY SHOW SWEETALERT
                     * -------------------------------------------------
                     */

                    let confirmResult;


                    try {

                        confirmResult =
                            await Swal.fire({

                                icon:
                                    "warning",

                                title:
                                    "CONFIRM CHECK-OUT",

                                html:
                                    `
                                    <div
                                        style="
                                            font-size:16px;
                                            line-height:1.7;
                                        "
                                    >

                                        <div
                                            style="
                                                font-weight:600;
                                                margin-bottom:10px;
                                            "
                                        >
                                            Are you sure you want
                                            to check out?
                                        </div>

                                        ${
                                            teacherName
                                                ? `
                                                    <div>
                                                        Teacher:
                                                        <strong>
                                                            ${teacherName}
                                                        </strong>
                                                    </div>
                                                `
                                                : ""
                                        }

                                        <div
                                            style="
                                                margin-top:8px;
                                                font-size:14px;
                                                color:#6b7280;
                                            "
                                        >
                                            This will record the
                                            teacher's checkout time.
                                        </div>

                                    </div>
                                    `,

                                showCancelButton:
                                    true,

                                confirmButtonText:
                                    "Yes, Checkout",

                                cancelButtonText:
                                    "Cancel",

                                confirmButtonColor:
                                    PRIMARY_ORANGE,

                                cancelButtonColor:
                                    "#6b7280",

                                reverseButtons:
                                    true,

                                allowOutsideClick:
                                    false,

                                allowEscapeKey:
                                    true,

                                focusCancel:
                                    true,

                                /*
                                 * CRITICAL:
                                 *
                                 * SweetAlert must NOT attempt
                                 * to restore focus to the
                                 * camera/scanner element.
                                 */

                                returnFocus:
                                    false,

                                /*
                                 * Prevent SweetAlert from
                                 * interacting unnecessarily
                                 * with the scanner DOM.
                                 */

                                didOpen:
                                    () => {

                                        try {

                                            const popup =
                                                Swal.getPopup();

                                            if (
                                                popup
                                            ) {

                                                popup.setAttribute(
                                                    "tabindex",
                                                    "-1"
                                                );

                                            }

                                        } catch (
                                            popupError
                                        ) {

                                            console.warn(
                                                "SweetAlert popup setup warning:",
                                                popupError
                                            );

                                        }

                                    },

                            });

                    } catch (
                        confirmationError
                    ) {

                        /*
                         * ---------------------------------------------
                         * SWEETALERT CLOSED UNEXPECTEDLY
                         * ---------------------------------------------
                         */

                        console.warn(
                            "Checkout confirmation closed:",
                            confirmationError
                        );


                        confirmResult = {

                            isConfirmed:
                                false,

                            isDenied:
                                false,

                            isDismissed:
                                true,

                        };

                    }


                    /*
                     * =================================================
                     * CHECKOUT CANCELLED
                     * =================================================
                     *
                     * THIS IS THE MOST IMPORTANT PART.
                     *
                     * Cancel must NOT:
                     *
                     * - logout
                     * - reload
                     * - navigate
                     * - stop camera
                     * - reset camera
                     * - clear authentication
                     * - clear localStorage
                     * - call API
                     * - play error sound
                     *
                     * =================================================
                     */

                    if (
                        !confirmResult ||
                        !confirmResult.isConfirmed
                    ) {

                        /*
                         * -------------------------------------------------
                         * CLOSE SWEETALERT COMPLETELY
                         * -------------------------------------------------
                         */

                        try {

                            if (
                                Swal.isVisible()
                            ) {

                                Swal.close();

                            }

                        } catch (
                            swalCloseError
                        ) {

                            console.warn(
                                "SweetAlert close warning:",
                                swalCloseError
                            );

                        }


                        /*
                         * -------------------------------------------------
                         * CLEAR TEMPORARY RESULT ONLY
                         * -------------------------------------------------
                         */

                        if (
                            mountedRef.current
                        ) {

                            setError(
                                null
                            );

                            setProcessingScan(
                                false
                            );

                        }


                        /*
                         * -------------------------------------------------
                         * RELEASE SCAN REF LOCK
                         * -------------------------------------------------
                         */

                        processingScanRef.current =
                            false;


                        /*
                         * -------------------------------------------------
                         * IMPORTANT:
                         *
                         * DO NOT TOUCH:
                         *
                         * scannerControlsRef
                         * scannerRef
                         * mediaStreamRef
                         * videoRef
                         * authentication
                         * localStorage
                         * navigation
                         *
                         * -------------------------------------------------
                         */


                        return;

                    }


                    /*
                     * =================================================
                     * USER CONFIRMED CHECKOUT
                     * =================================================
                     */

                    const checkoutPayload = {

                        qr_token:
                            qrToken,

                        device_id:
                            scannerDevice.device_id,

                        confirm_checkout:
                            true,

                    };


                    /*
                     * =================================================
                     * CONFIRMED CHECKOUT REQUEST
                     * =================================================
                     */

                    const checkoutResponse =
                        await api.post(
                            SCAN_ENDPOINT,
                            checkoutPayload,
                            {
                                timeout:
                                    15000,

                                headers: {
                                    "Content-Type":
                                        "application/json",
                                },
                            }
                        );


                    /*
                     * =================================================
                     * CHECKOUT RESPONSE
                     * =================================================
                     */

                    const checkoutData =
                        checkoutResponse?.data ||
                        {};


                    /*
                     * =================================================
                     * CHECKOUT ACTION
                     * =================================================
                     */

                    const checkoutAction =
                        normalizeAction(
                            checkoutData.action ||
                            checkoutData.attendance_action
                        );


                    /*
                     * =================================================
                     * CHECKOUT RESULT TYPE
                     * =================================================
                     */

                    const checkoutResultType =
                        getResultType(
                            checkoutData,
                            checkoutAction
                        );


                    /*
                     * =================================================
                     * CHECKOUT TEACHER
                     * =================================================
                     */

                    const checkoutTeacher =
                        checkoutData.teacher ||
                        teacher ||
                        null;


                    /*
                     * =================================================
                     * CHECKOUT ATTENDANCE
                     * =================================================
                     */

                    const checkoutAttendance =
                        checkoutData.attendance ||
                        null;


                    /*
                     * =================================================
                     * CHECKOUT TEACHER NAME
                     * =================================================
                     */

                    const checkoutTeacherName =
                        getTeacherName(
                            checkoutTeacher
                        );


                    /*
                     * =================================================
                     * CHECKOUT MESSAGE
                     * =================================================
                     */

                    const checkoutMessage =
                        checkoutData.message ||
                        "Teacher checked out successfully.";


                    /*
                     * =================================================
                     * CHECKOUT TIME
                     * =================================================
                     */

                    const checkoutTime =
                        checkoutData.timestamp ||
                        checkoutData.scanned_at ||
                        new Date().toISOString();


                    /*
                     * =================================================
                     * CHECKOUT GATE
                     * =================================================
                     */

                    const checkoutGate =
                        checkoutData.gate ||
                        checkoutData.gate_name ||
                        scannerDevice.gate_name ||
                        null;


                    /*
                     * =================================================
                     * CHECKOUT DEVICE
                     * =================================================
                     */

                    const checkoutDevice =
                        checkoutData.device ||
                        scannerDevice ||
                        null;


                    /*
                     * =================================================
                     * CHECKOUT SUCCESS
                     * =================================================
                     */

                    if (
                        checkoutResultType ===
                            "success" ||

                        checkoutAction ===
                            "check_out"
                    ) {

                        setResult({

                            type:
                                "success",

                            action:
                                "check_out",

                            message:
                                checkoutMessage,

                            teacher:
                                checkoutTeacher,

                            card:
                                checkoutData.card ||
                                null,

                            time:
                                checkoutTime,

                            gate:
                                checkoutGate,

                            device:
                                checkoutDevice,

                            attendance:
                                checkoutAttendance,

                        });


                        /*
                         * -------------------------------------------------
                         * UPDATE SCAN COUNT
                         * -------------------------------------------------
                         */

                        setScanCount(
                            previous =>
                                previous + 1
                        );


                        /*
                         * -------------------------------------------------
                         * UPDATE LAST SCAN
                         * -------------------------------------------------
                         */

                        setLastScanAt(
                            new Date()
                        );


                        /*
                         * -------------------------------------------------
                         * UPDATE DEVICE
                         * -------------------------------------------------
                         */

                        if (
                            checkoutData.device
                        ) {

                            setScannerDevice(
                                checkoutData.device
                            );

                        }


                        /*
                         * -------------------------------------------------
                         * SUCCESS SOUND ONLY
                         * -------------------------------------------------
                         */

                        await playSuccessSound();


                        /*
                         * -------------------------------------------------
                         * SUCCESS ALERT
                         * -------------------------------------------------
                         */

                        showSuccessAlert({

                            title:
                                "CHECK-OUT SUCCESSFUL",

                            message:
                                checkoutMessage,

                            teacherName:
                                checkoutTeacherName,

                            action:
                                "check_out",

                            time:
                                formatTime(
                                    checkoutTime
                                ),

                            gate:
                                checkoutGate,

                        });


                        /*
                         * -------------------------------------------------
                         * CLEAR RESULT
                         * -------------------------------------------------
                         */

                        scheduleResultClear(
                            5000
                        );


                        return;

                    }


                    /*
                     * =================================================
                     * CHECKOUT FAILED
                     * =================================================
                     */

                    const checkoutErrorMessage =
                        checkoutData.message ||
                        "Unable to complete teacher checkout.";


                    setResult({

                        type:
                            "error",

                        action:
                            checkoutAction ||
                            "rejected",

                        message:
                            checkoutErrorMessage,

                        teacher:
                            checkoutTeacher,

                        card:
                            checkoutData.card ||
                            null,

                        time:
                            checkoutTime,

                        gate:
                            checkoutGate,

                        device:
                            checkoutDevice,

                        attendance:
                            checkoutAttendance,

                    });


                    setRejectedCount(
                        previous =>
                            previous + 1
                    );


                    setError(
                        checkoutErrorMessage
                    );


                    await playErrorSound();


                    showErrorAlert({

                        message:
                            checkoutErrorMessage,

                        teacherName:
                            checkoutTeacherName,

                        time:
                            formatTime(
                                checkoutTime
                            ),

                        gate:
                            checkoutGate,

                    });


                    scheduleResultClear(
                        5000
                    );


                    return;

                }


                /*
                 * =====================================================
                 * NORMAL SUCCESS
                 * =====================================================
                 */

                if (
                    resultType ===
                    "success"
                ) {

                    setResult({

                        type:
                            "success",

                        action,

                        message,

                        teacher,

                        card:
                            data.card ||
                            null,

                        time:
                            scanTime,

                        gate,

                        device:
                            responseDevice,

                        attendance,

                    });


                    setScanCount(
                        previous =>
                            previous + 1
                    );


                    setLastScanAt(
                        new Date()
                    );


                    if (
                        data.device
                    ) {

                        setScannerDevice(
                            data.device
                        );

                    }


                    await playSuccessSound();


                    showSuccessAlert({

                        title:
                            action ===
                            "check_out"

                                ? "CHECK-OUT SUCCESSFUL"

                                : "CHECK-IN SUCCESSFUL",

                        message,

                        teacherName,

                        action,

                        time:
                            formatTime(
                                scanTime
                            ),

                        gate,

                    });


                    scheduleResultClear(
                        5000
                    );


                    return;

                }


                /*
                 * =====================================================
                 * DUPLICATE
                 * =====================================================
                 */

                if (
                    resultType ===
                    "duplicate"
                ) {

                    setResult({

                        type:
                            "duplicate",

                        action:
                            "duplicate",

                        message,

                        teacher,

                        card:
                            data.card ||
                            null,

                        time:
                            scanTime,

                        gate,

                        device:
                            responseDevice,

                        attendance,

                    });


                    setDuplicateCount(
                        previous =>
                            previous + 1
                    );


                    setLastScanAt(
                        new Date()
                    );


                    await playErrorSound();


                    showDuplicateAlert({

                        message,

                        teacherName,

                        time:
                            formatTime(
                                scanTime
                            ),

                        gate,

                    });


                    scheduleResultClear(
                        5000
                    );


                    return;

                }


                /*
                 * =====================================================
                 * REJECTED
                 * =====================================================
                 */

                if (
                    action ===
                    "rejected"
                ) {

                    setResult({

                        type:
                            "error",

                        action:
                            "rejected",

                        message,

                        teacher,

                        card:
                            data.card ||
                            null,

                        time:
                            scanTime,

                        gate,

                        device:
                            responseDevice,

                        attendance,

                    });


                    setRejectedCount(
                        previous =>
                            previous + 1
                    );


                    setError(
                        message
                    );


                    await playErrorSound();


                    showErrorAlert({

                        message,

                        teacherName,

                        time:
                            formatTime(
                                scanTime
                            ),

                        gate,

                    });


                    scheduleResultClear(
                        5000
                    );


                    return;

                }


                /*
                 * =====================================================
                 * UNKNOWN RESPONSE
                 * =====================================================
                 */

                setResult({

                    type:
                        "error",

                    action:
                        "unknown",

                    message,

                    teacher,

                    card:
                        data.card ||
                        null,

                    time:
                        scanTime,

                    gate,

                    device:
                        responseDevice,

                    attendance,

                });


                setRejectedCount(
                    previous =>
                        previous + 1
                );


                setError(
                    message
                );


                await playErrorSound();


                showErrorAlert({

                    message,

                    teacherName,

                    time:
                        formatTime(
                            scanTime
                        ),

                    gate,

                });


                scheduleResultClear(
                    5000
                );


            } catch (
                scanError
            ) {

                /*
                 * =====================================================
                 * ERROR LOG
                 * =====================================================
                 */

                console.error(
                    "Attendance scan failed:",
                    scanError
                );


                /*
                 * =====================================================
                 * RESPONSE DATA
                 * =====================================================
                 */

                const responseData =
                    scanError?.response?.data ||
                    {};


                /*
                 * =====================================================
                 * STATUS
                 * =====================================================
                 */

                const status =
                    scanError?.response?.status;


                /*
                 * =====================================================
                 * BACKEND MESSAGE
                 * =====================================================
                 */

                const backendMessage =
                    responseData.message ||
                    responseData.detail ||
                    responseData.error ||
                    (
                        Array.isArray(
                            responseData.non_field_errors
                        )
                            ? responseData
                                .non_field_errors[0]

                            : null
                    ) ||
                    null;


                /*
                 * =====================================================
                 * ACTION
                 * =====================================================
                 */

                let action =
                    normalizeAction(
                        responseData.action ||
                        responseData.attendance_action ||
                        responseData.error
                    );


                /*
                 * =====================================================
                 * HTTP 409 = DUPLICATE
                 * =====================================================
                 */

                if (
                    status ===
                    409
                ) {

                    action =
                        "duplicate";

                }


                /*
                 * =====================================================
                 * ALREADY COMPLETED
                 * =====================================================
                 */

                if (
                    responseData.action ===
                    "ALREADY_COMPLETED"
                ) {

                    action =
                        "duplicate";

                }


                /*
                 * =====================================================
                 * DEFAULT REJECTION
                 * =====================================================
                 */

                if (
                    !action &&
                    status >= 400
                ) {

                    action =
                        "rejected";

                }


                /*
                 * =====================================================
                 * ERROR MESSAGE
                 * =====================================================
                 */

                const message =
                    backendMessage ||
                    (
                        action ===
                        "duplicate"

                            ? "Teacher attendance has already been completed for today."

                            : "This QR scan was rejected."
                    );


                /*
                 * =====================================================
                 * ERROR TIME
                 * =====================================================
                 */

                const errorTime =
                    responseData.timestamp ||
                    responseData.scanned_at ||
                    new Date().toISOString();


                /*
                 * =====================================================
                 * ERROR TEACHER
                 * ===================================================== */

                const errorTeacher =
                    responseData.teacher ||
                    null;


                const errorTeacherName =
                    getTeacherName(
                        errorTeacher
                    );


                /*
                 * =====================================================
                 * ERROR GATE
                 * =====================================================
                 */

                const errorGate =
                    responseData.gate ||
                    responseData.gate_name ||
                    scannerDevice?.gate_name ||
                    null;


                /*
                 * =====================================================
                 * REFRESH DEVICE IF NECESSARY
                 * =====================================================
                 */

                const messageText =
                    String(
                        message
                    ).toLowerCase();


                if (
                    status === 400 ||
                    status === 403 ||
                    status === 404
                ) {

                    if (
                        messageText.includes(
                            "device"
                        ) &&
                        (
                            messageText.includes(
                                "register"
                            ) ||
                            messageText.includes(
                                "active"
                            ) ||
                            messageText.includes(
                                "invalid"
                            )
                        )
                    ) {

                        await loadScannerDevice();

                    }

                }


                /*
                 * =====================================================
                 * DUPLICATE ERROR
                 * =====================================================
                 */

                if (
                    action ===
                    "duplicate"
                ) {

                    setResult({

                        type:
                            "duplicate",

                        action:
                            "duplicate",

                        message,

                        teacher:
                            errorTeacher,

                        card:
                            responseData.card ||
                            null,

                        time:
                            errorTime,

                        gate:
                            errorGate,

                        device:
                            responseData.device ||
                            scannerDevice ||
                            null,

                        attendance:
                            responseData.attendance ||
                            null,

                    });


                    setDuplicateCount(
                        previous =>
                            previous + 1
                    );


                    setLastScanAt(
                        new Date()
                    );


                    await playErrorSound();


                    showDuplicateAlert({

                        message,

                        teacherName:
                            errorTeacherName,

                        time:
                            formatTime(
                                errorTime
                            ),

                        gate:
                            errorGate,

                    });


                    scheduleResultClear(
                        5000
                    );


                    return;

                }


                /*
                 * =====================================================
                 * REAL REJECTION
                 * =====================================================
                 */

                setResult({

                    type:
                        "error",

                    action:
                        "rejected",

                    message,

                    teacher:
                        errorTeacher,

                    card:
                        responseData.card ||
                        null,

                    time:
                        errorTime,

                    gate:
                        errorGate,

                    device:
                        responseData.device ||
                        scannerDevice ||
                        null,

                    attendance:
                        responseData.attendance ||
                        null,

                });


                setRejectedCount(
                    previous =>
                        previous + 1
                );


                setError(
                    message
                );


                await playErrorSound();


                showErrorAlert({

                    message,

                    teacherName:
                        errorTeacherName,

                    time:
                        formatTime(
                            errorTime
                        ),

                    gate:
                        errorGate,

                });


                scheduleResultClear(
                    5000
                );


            } finally {

                /*
                 * =====================================================
                 * FINAL SCAN LOCK RELEASE
                 * =====================================================
                 *
                 * This always executes.
                 *
                 * =====================================================
                 */

                processingScanRef.current =
                    false;


                if (
                    mountedRef.current
                ) {

                    setProcessingScan(
                        false
                    );

                }

            }

        },
        [
            
            deviceOnline,
            scannerDevice,
            normalizeAction,
            getResultType,
            getTeacherName,
            formatTime,
            loadScannerDevice,
            scheduleResultClear,
            playSuccessSound,
            playErrorSound,
            showSuccessAlert,
            showDuplicateAlert,
            showErrorAlert,
        ]
    );


    /* =====================================================
       HANDLE QR SCAN
       ===================================================== */

    const handleQrScan =
        useCallback(
            async (
                decodedText,
                decodedResult
            ) => {

                if (!decodedText) {
                    return;
                }


                if (
                    processingScanRef.current
                ) {

                    return;

                }


                const token =
                    decodedText.trim();


                if (!token) {
                    return;
                }


                const now =
                    Date.now();


                /*
                 * Prevent the same QR from being submitted
                 * repeatedly while it remains in the camera.
                 */

                const isSameRecentScan =
                    lastScannedTokenRef.current ===
                        token &&
                    now -
                        lastScannedTimeRef.current <
                        4000;


                if (
                    isSameRecentScan
                ) {

                    return;

                }


                lastScannedTokenRef.current =
                    token;

                lastScannedTimeRef.current =
                    now;


                await processAttendanceScan(
                    token
                );

            },
            [
                processAttendanceScan,
            ]
        );


    /* =====================================================
       BUILD CAMERA OPTIONS
       ===================================================== */




const getCameraOptions =
    useCallback(
        cameras => {

            return (
                cameras || []
            ).map(
                (
                    camera,
                    index
                ) => {

                    let type =
                        "Camera";


                    if (
                        isBackCamera(
                            camera
                        )
                    ) {

                        type =
                            "Back Camera";

                    } else if (
                        isFrontCamera(
                            camera
                        )
                    ) {

                        type =
                            "Front Camera";

                    }


                    return {

                        value:
                            camera.deviceId,

                        label:
                            camera.label
                                ? `${type} — ${camera.label}`
                                : `${type} ${index + 1}`,

                    };

                }
            );

        },
        [
            isBackCamera,
            isFrontCamera,
        ]
    );

    /* =====================================================
       START SCANNER
       ===================================================== */

// const stopScanner =
//     useCallback(
//         async () => {

//             /*
//              * =====================================================
//              * STOP ZXING CONTROLS
//              * =====================================================
//              */

//             try {

//                 if (
//                     scannerControlsRef.current
//                 ) {

//                     scannerControlsRef.current.stop();

//                 }

//             } catch (
//                 controlsError
//             ) {

//                 console.warn(
//                     "ZXing controls stop warning:",
//                     controlsError
//                 );

//             }


//             /*
//              * =====================================================
//              * RESET ZXING READER
//              * =====================================================
//              */

//             try {

//                 if (
//                     scannerRef.current
//                 ) {

//                     scannerRef.current.reset();

//                 }

//             } catch (
//                 readerError
//             ) {

//                 console.warn(
//                     "ZXing reset warning:",
//                     readerError
//                 );

//             }


//             /*
//              * =====================================================
//              * STOP ACTUAL CAMERA STREAM
//              * =====================================================
//              */

//             try {

//                 if (
//                     mediaStreamRef.current
//                 ) {

//                     mediaStreamRef.current
//                         .getTracks()
//                         .forEach(
//                             track => {

//                                 try {

//                                     track.stop();

//                                 } catch (
//                                     trackError
//                                 ) {}

//                             }
//                         );

//                 }

//             } catch (
//                 streamError
//             ) {

//                 console.warn(
//                     "MediaStream cleanup warning:",
//                     streamError
//                 );

//             }


//             /*
//              * =====================================================
//              * CLEAR VIDEO
//              * =====================================================
//              */

//             try {

//                 if (
//                     videoRef.current
//                 ) {

//                     videoRef.current.pause();

//                     videoRef.current.srcObject =
//                         null;

//                 }

//             } catch (
//                 videoError
//             ) {

//                 console.warn(
//                     "Video cleanup warning:",
//                     videoError
//                 );

//             }


//             /*
//              * =====================================================
//              * RESET REFS
//              * =====================================================
//              */

//             scannerControlsRef.current =
//                 null;

//             scannerRef.current =
//                 null;

//             mediaStreamRef.current =
//                 null;


//             /*
//              * =====================================================
//              * STATE
//              * =====================================================
//              */

//             if (
//                 mountedRef.current
//             ) {

//                 setScannerRunning(
//                     false
//                 );

//             }

//         },
//         []
//     );

const stopScanner = useCallback(
    async () => {
        try {
            if (
                scannerControlsRef.current &&
                typeof scannerControlsRef.current.stop === "function"
            ) {
                scannerControlsRef.current.stop();
            }
        } catch (controlsError) {
            console.warn(
                "ZXing controls stop warning:",
                controlsError
            );
        }

        try {
            const stream = mediaStreamRef.current;

            if (stream) {
                const tracks = stream.getTracks();

                tracks.forEach(track => {
                    try {
                        track.stop();
                    } catch (trackError) {
                        console.warn(
                            "Camera track stop warning:",
                            trackError
                        );
                    }
                });
            }
        } catch (streamError) {
            console.warn(
                "MediaStream cleanup warning:",
                streamError
            );
        }

        try {
            const video = videoRef.current;

            if (video) {
                const videoStream = video.srcObject;

                if (
                    videoStream &&
                    typeof videoStream.getTracks === "function"
                ) {
                    videoStream
                        .getTracks()
                        .forEach(track => {
                            try {
                                track.stop();
                            } catch (trackError) {}
                        });
                }

                video.pause();
                video.srcObject = null;
            }
        } catch (videoError) {
            console.warn(
                "Video cleanup warning:",
                videoError
            );
        }

        scannerControlsRef.current = null;
        scannerRef.current = null;
        mediaStreamRef.current = null;

        if (mountedRef.current) {
            setScannerRunning(false);
        }
    },
    []
);

const startScanner =
    useCallback(
        async (
            requestedCameraId = null,
            requestedFacingMode = null
        ) => {

            /*
             * =====================================================
             * PREVENT DOUBLE START
             * =====================================================
             */

            if (
                startingScannerRef.current
            ) {

                console.warn(
                    "Scanner startup already in progress."
                );

                return;

            }


            /*
             * =====================================================
             * DEVICE ONLINE CHECK
             *
             * NOTE:
             * Academic year is NOT checked here.
             * The backend determines the active academic year.
             * =====================================================
             */

            if (
                !deviceOnline
            ) {

                setError(
                    "This device is offline."
                );

                return;

            }


            /*
             * =====================================================
             * SCANNER DEVICE CHECK
             * =====================================================
             */

            if (
                !scannerDevice ||
                !scannerDevice.device_id
            ) {

                setError(
                    "This scanner device is not registered."
                );

                return;

            }


            /*
             * =====================================================
             * SCANNER DEVICE ACTIVE CHECK
             * =====================================================
             */

            if (
                scannerDevice.is_active === false
            ) {

                setError(
                    "This scanner device has been deactivated."
                );

                return;

            }


            /*
             * =====================================================
             * LOCK SCANNER STARTUP
             * =====================================================
             */

            startingScannerRef.current =
                true;

            setInitializingScanner(
                true
            );

            setCameraError(
                null
            );

            setError(
                null
            );


            let cameras = [];

            let stream = null;


            /*
             * =====================================================
             * EXPLICIT CAMERA REQUEST
             * =====================================================
             */

            const explicitlyRequestedCameraId =
                requestedCameraId ||
                null;


            /*
             * =====================================================
             * EXPLICIT FACING MODE REQUEST
             *
             * user        = FRONT CAMERA
             * environment = BACK CAMERA
             * =====================================================
             */

            const explicitlyRequestedFacingMode =
                requestedFacingMode === "user" ||
                requestedFacingMode === "environment"
                    ? requestedFacingMode
                    : null;


            /*
             * =====================================================
             * INITIAL CAMERA ID
             * =====================================================
             */

            let cameraId =
                explicitlyRequestedCameraId ||
                (
                    explicitlyRequestedFacingMode
                        ? null
                        : selectedCameraRef.current
                ) ||
                null;


            try {

                /*
                 * =================================================
                 * UNLOCK AUDIO
                 * =================================================
                 */

                await unlockAudio();


                /*
                 * =================================================
                 * STOP PREVIOUS SCANNER
                 * =================================================
                 */

                await stopScanner();


                /*
                 * =================================================
                 * VIDEO ELEMENT
                 * =================================================
                 */

                const video =
                    videoRef.current;


                if (
                    !video
                ) {

                    throw new Error(
                        "Camera video element is not available."
                    );

                }


                /*
                 * =================================================
                 * LOAD AVAILABLE CAMERAS
                 * =================================================
                 */

                cameras =
                    await loadCameraList();


                /*
                 * =================================================
                 * REQUEST CAMERA PERMISSION
                 *
                 * Some mobile browsers hide camera labels until
                 * permission has been granted.
                 * =================================================
                 */

                const permissionRequired =
                    cameras.length === 0 ||
                    cameras.every(
                        camera =>
                            !camera.label
                    );


                if (
                    permissionRequired
                ) {

                    let permissionStream =
                        null;


                    try {

                        permissionStream =
                            await navigator.mediaDevices.getUserMedia(
                                {
                                    video:
                                        true,

                                    audio:
                                        false,
                                }
                            );


                        setCameraPermissionGranted(
                            true
                        );

                    } finally {

                        if (
                            permissionStream
                        ) {

                            permissionStream
                                .getTracks()
                                .forEach(
                                    track => {

                                        try {

                                            track.stop();

                                        } catch (
                                            cleanupError
                                        ) {}

                                    }
                                );

                        }

                    }


                    /*
                     * Reload cameras after permission.
                     */

                    cameras =
                        await loadCameraList();

                }


                /*
                 * =================================================
                 * VERIFY CAMERA LIST
                 * =================================================
                 */

                if (
                    !cameras ||
                    cameras.length === 0
                ) {

                    throw new Error(
                        "No camera was found on this device."
                    );

                }


                /*
                 * =================================================
                 * CAMERA SELECTION
                 *
                 * FACING MODE HAS PRIORITY.
                 *
                 * user        = FRONT CAMERA
                 * environment = BACK CAMERA
                 * =================================================
                 */

                if (
                    explicitlyRequestedFacingMode
                ) {

                    cameraId =
                        null;


                    console.log(
                        "Using requested facing mode:",
                        explicitlyRequestedFacingMode
                    );

                }


                /*
                 * =================================================
                 * EXPLICIT DEVICE CAMERA
                 * =================================================
                 */

                else if (
                    explicitlyRequestedCameraId
                ) {

                    const requestedExists =
                        cameras.some(
                            camera =>
                                camera.deviceId ===
                                explicitlyRequestedCameraId
                        );


                    if (
                        !requestedExists
                    ) {

                        throw new Error(
                            "The selected camera is no longer available. Please refresh the camera list and try again."
                        );

                    }


                    cameraId =
                        explicitlyRequestedCameraId;


                    console.log(
                        "Explicit camera requested:",
                        cameraId
                    );

                }


                /*
                 * =================================================
                 * PREVIOUSLY SELECTED CAMERA
                 * =================================================
                 */

                else if (
                    selectedCameraRef.current
                ) {

                    const previousCameraExists =
                        cameras.some(
                            camera =>
                                camera.deviceId ===
                                selectedCameraRef.current
                        );


                    if (
                        previousCameraExists
                    ) {

                        cameraId =
                            selectedCameraRef.current;


                        console.log(
                            "Using previously selected camera:",
                            cameraId
                        );

                    } else {

                        cameraId =
                            null;

                    }

                }


                /*
                 * =================================================
                 * DEFAULT REAR CAMERA
                 *
                 * ONLY WHEN NO FACING MODE WAS REQUESTED.
                 * =================================================
                 */

                if (
                    !explicitlyRequestedFacingMode &&
                    !cameraId
                ) {

                    const rearCamera =
                        cameras.find(
                            camera =>
                                isBackCamera(
                                    camera
                                )
                        );


                    if (
                        rearCamera
                    ) {

                        cameraId =
                            rearCamera.deviceId;


                        console.log(
                            "Using rear camera:",
                            cameraId
                        );

                    }

                }


                /*
                 * =================================================
                 * LAST DEVICE-ID FALLBACK
                 * =================================================
                 */

                if (
                    !explicitlyRequestedFacingMode &&
                    !cameraId
                ) {

                    cameraId =
                        cameras[0]?.deviceId ||
                        null;

                }


                /*
                 * =================================================
                 * DEVICE-ID VALIDATION
                 *
                 * NOT REQUIRED WHEN USING FACING MODE.
                 * =================================================
                 */

                if (
                    !explicitlyRequestedFacingMode &&
                    !cameraId
                ) {

                    throw new Error(
                        "Unable to determine the selected camera."
                    );

                }


                /*
                 * =================================================
                 * FINAL CAMERA INFORMATION
                 * =================================================
                 */

                const finalCamera =
                    cameraId
                        ? cameras.find(
                            camera =>
                                camera.deviceId ===
                                cameraId
                        )
                        : null;


                console.log(
                    "FINAL CAMERA REQUEST:",
                    {
                        deviceId:
                            cameraId,

                        label:
                            finalCamera?.label ||
                            "Using facing mode",

                        facingMode:
                            explicitlyRequestedFacingMode,

                        explicitlyRequestedCamera:
                            Boolean(
                                explicitlyRequestedCameraId
                            ),

                        explicitlyRequestedFacing:
                            Boolean(
                                explicitlyRequestedFacingMode
                            ),
                    }
                );


                /*
                 * =================================================
                 * CAMERA CONSTRAINTS
                 *
                 * MOBILE:
                 *
                 * user        = FRONT
                 * environment = BACK
                 *
                 * DEVICE SELECTION:
                 *
                 * deviceId exact
                 * =================================================
                 */

                const videoConstraints =
                    explicitlyRequestedFacingMode
                        ? {
                              facingMode:
                                  explicitlyRequestedFacingMode,

                              width: {
                                  ideal:
                                      1280,
                              },

                              height: {
                                  ideal:
                                      720,
                              },

                              frameRate: {
                                  ideal:
                                      30,

                                  max:
                                      30,
                              },
                          }
                        : {
                              deviceId: {
                                  exact:
                                      cameraId,
                              },

                              width: {
                                  ideal:
                                      1280,
                              },

                              height: {
                                  ideal:
                                      720,
                              },

                              frameRate: {
                                  ideal:
                                      30,

                                  max:
                                      30,
                              },
                          };


                /*
                 * =================================================
                 * OPEN CAMERA
                 * =================================================
                 */

                console.log(
                    "REQUESTING CAMERA:",
                    videoConstraints
                );


                try {

                    stream =
                        await navigator.mediaDevices.getUserMedia(
                            {
                                video:
                                    videoConstraints,

                                audio:
                                    false,
                            }
                        );


                    console.log(
                        "Camera opened successfully:",
                        {
                            requestedCamera:
                                cameraId,

                            requestedFacingMode:
                                explicitlyRequestedFacingMode,
                        }
                    );

                } catch (
                    cameraError
                ) {

                    console.error(
                        "Camera failed:",
                        {
                            requestedCamera:
                                cameraId,

                            requestedFacingMode:
                                explicitlyRequestedFacingMode,

                            error:
                                cameraError,
                        }
                    );


                    /*
                     * =================================================
                     * NEVER FALL BACK TO ANOTHER CAMERA WHEN USER
                     * EXPLICITLY REQUESTED FRONT/BACK.
                     * =================================================
                     */

                    if (
                        explicitlyRequestedFacingMode
                    ) {

                        throw cameraError;

                    }


                    /*
                     * =================================================
                     * DEVICE-ID FALLBACK
                     *
                     * ONLY FOR NORMAL DEVICE START.
                     * =================================================
                     */

                    console.warn(
                        "Default camera failed. Trying another available camera."
                    );


                    for (
                        const camera
                        of cameras
                    ) {

                        if (
                            camera.deviceId ===
                            cameraId
                        ) {

                            continue;

                        }


                        try {

                            stream =
                                await navigator.mediaDevices.getUserMedia(
                                    {
                                        video: {
                                            deviceId: {
                                                exact:
                                                    camera.deviceId,
                                            },

                                            width: {
                                                ideal:
                                                    1280,
                                            },

                                            height: {
                                                ideal:
                                                    720,
                                            },

                                            frameRate: {
                                                ideal:
                                                    30,

                                                max:
                                                    30,
                                            },
                                        },

                                        audio:
                                            false,
                                    }
                                );


                            cameraId =
                                camera.deviceId;


                            console.log(
                                "Fallback camera opened:",
                                cameraId
                            );


                            break;

                        } catch (
                            fallbackError
                        ) {

                            console.warn(
                                "Fallback camera failed:",
                                camera.deviceId,
                                fallbackError
                            );

                        }

                    }

                }


                /*
                 * =================================================
                 * FINAL STREAM CHECK
                 * =================================================
                 */

                if (
                    !stream
                ) {

                    throw new Error(
                        "Unable to open any available camera."
                    );

                }


                /*
                 * =================================================
                 * VIDEO TRACK
                 * =================================================
                 */

                const videoTrack =
                    stream.getVideoTracks()[0];


                if (
                    !videoTrack
                ) {

                    throw new Error(
                        "Camera opened but no video track was created."
                    );

                }


                /*
                 * =================================================
                 * ACTUAL CAMERA SETTINGS
                 * =================================================
                 */

                const actualSettings =
                    videoTrack.getSettings?.();


                const actualDeviceId =
                    actualSettings?.deviceId ||
                    cameraId ||
                    null;


                /*
                 * =================================================
                 * ACTIVE CAMERA
                 * =================================================
                 */

                if (
                    actualDeviceId
                ) {

                    cameraId =
                        actualDeviceId;

                }


                console.log(
                    "ACTIVE CAMERA:",
                    {
                        deviceId:
                            actualDeviceId,

                        label:
                            videoTrack.label,

                        facingMode:
                            actualSettings?.facingMode,

                        requestedFacingMode:
                            explicitlyRequestedFacingMode,

                        width:
                            actualSettings?.width,

                        height:
                            actualSettings?.height,

                        frameRate:
                            actualSettings?.frameRate,
                    }
                );


                /*
                 * =================================================
                 * SAVE FACING MODE
                 * =================================================
                 */

                if (
                    explicitlyRequestedFacingMode
                ) {

                    selectedFacingModeRef.current =
                        explicitlyRequestedFacingMode;

                } else {

                    selectedFacingModeRef.current =
                        actualSettings?.facingMode ||
                        null;

                }


                /*
                 * =================================================
                 * SAVE CAMERA DEVICE
                 * =================================================
                 */

                if (
                    actualDeviceId
                ) {

                    selectedCameraRef.current =
                        actualDeviceId;


                    setSelectedCameraId(
                        actualDeviceId
                    );

                }


                /*
                 * =================================================
                 * SAVE MEDIA STREAM
                 * =================================================
                 */

                mediaStreamRef.current =
                    stream;


                /*
                 * =================================================
                 * CONNECT STREAM TO VIDEO
                 * =================================================
                 */

                video.srcObject =
                    stream;

                video.muted =
                    true;

                video.autoplay =
                    true;

                video.playsInline =
                    true;


                video.setAttribute(
                    "autoplay",
                    ""
                );

                video.setAttribute(
                    "muted",
                    ""
                );

                video.setAttribute(
                    "playsinline",
                    ""
                );


                /*
                 * =================================================
                 * WAIT FOR VIDEO METADATA
                 * =================================================
                 */

                await new Promise(
                    (
                        resolve,
                        reject
                    ) => {

                        let finished =
                            false;


                        const finish =
                            () => {

                                if (
                                    finished
                                ) {

                                    return;

                                }


                                finished =
                                    true;


                                resolve();

                            };


                        const fail =
                            () => {

                                if (
                                    finished
                                ) {

                                    return;

                                }


                                finished =
                                    true;


                                reject(
                                    new Error(
                                        "Camera video failed to load."
                                    )
                                );

                            };


                        video.onloadedmetadata =
                            finish;

                        video.onerror =
                            fail;


                        if (
                            video.readyState >=
                            1
                        ) {

                            finish();

                        }

                    }
                );


                /*
                 * =================================================
                 * START VIDEO
                 * =================================================
                 */

                await video.play();


                /*
                 * =================================================
                 * VERIFY VIDEO FRAMES
                 * =================================================
                 */

                if (
                    !video.videoWidth ||
                    !video.videoHeight
                ) {

                    throw new Error(
                        "Camera opened but no video frames are available."
                    );

                }


                console.log(
                    "LIVE VIDEO:",
                    {
                        width:
                            video.videoWidth,

                        height:
                            video.videoHeight,

                        facingMode:
                            actualSettings?.facingMode,
                    }
                );


                /*
                 * =================================================
                 * CREATE ZXING READER
                 * =================================================
                 */

                const reader =
                    new BrowserQRCodeReader();


                scannerRef.current =
                    reader;


                /*
                 * =================================================
                 * DECODE CALLBACK
                 * =================================================
                 */

                const handleDecode =
                    async (
                        result,
                        decodeError
                    ) => {

                        if (
                            !result
                        ) {

                            return;

                        }


                        try {

                            const decodedText =
                                result.getText();


                            if (
                                !decodedText
                            ) {

                                return;

                            }


                            await handleQrScan(
                                decodedText,
                                result
                            );

                        } catch (
                            scanError
                        ) {

                            console.error(
                                "QR scan handler error:",
                                scanError
                            );

                        }

                    };


                /*
                 * =================================================
                 * START ZXING
                 * =================================================
                 */

                const controls =
                    await reader.decodeFromVideoElement(
                        video,
                        handleDecode
                    );


                scannerControlsRef.current =
                    controls;


                /*
                 * =================================================
                 * SUCCESS
                 * =================================================
                 */

                setCameraPermissionGranted(
                    true
                );

                setScannerRunning(
                    true
                );

                setCameraError(
                    null
                );

                setError(
                    null
                );


                console.log(
                    "ZXing scanner started successfully:",
                    {
                        cameraId:
                            actualDeviceId,

                        cameraLabel:
                            videoTrack.label,

                        facingMode:
                            actualSettings?.facingMode,
                    }
                );


                /*
                 * =================================================
                 * REFRESH CAMERA LIST
                 * =================================================
                 */

                await loadCameraList();

            } catch (
                scannerError
            ) {

                console.error(
                    "ZXing scanner error:",
                    scannerError
                );


                /*
                 * =================================================
                 * STOP ZXING
                 * =================================================
                 */

                try {

                    if (
                        scannerControlsRef.current
                    ) {

                        scannerControlsRef.current.stop();

                    }

                } catch (
                    controlsError
                ) {

                    console.warn(
                        "ZXing controls cleanup error:",
                        controlsError
                    );

                }


                /*
                 * =================================================
                 * RESET ZXING
                 * =================================================
                 */

                try {

                    if (
                        scannerRef.current
                    ) {

                        scannerRef.current.reset();

                    }

                } catch (
                    resetError
                ) {

                    console.warn(
                        "ZXing reset error:",
                        resetError
                    );

                }


                /*
                 * =================================================
                 * STOP SAVED STREAM
                 * =================================================
                 */

                try {

                    if (
                        mediaStreamRef.current
                    ) {

                        mediaStreamRef.current
                            .getTracks()
                            .forEach(
                                track => {

                                    try {

                                        track.stop();

                                    } catch (
                                        trackError
                                    ) {}

                                }
                            );

                    }

                } catch (
                    streamError
                ) {

                    console.warn(
                        "Media stream cleanup error:",
                        streamError
                    );

                }


                /*
                 * =================================================
                 * STOP LOCAL STREAM
                 * =================================================
                 */

                try {

                    if (
                        stream
                    ) {

                        stream
                            .getTracks()
                            .forEach(
                                track => {

                                    try {

                                        track.stop();

                                    } catch (
                                        trackError
                                    ) {}

                                }
                            );

                    }

                } catch (
                    localStreamError
                ) {}


                /*
                 * =================================================
                 * CLEAR VIDEO
                 * =================================================
                 */

                try {

                    if (
                        videoRef.current
                    ) {

                        videoRef.current.pause();

                        videoRef.current.srcObject =
                            null;

                    }

                } catch (
                    videoError
                ) {

                    console.warn(
                        "Video cleanup error:",
                        videoError
                    );

                }


                /*
                 * =================================================
                 * CLEAR REFS
                 * =================================================
                 */

                scannerControlsRef.current =
                    null;

                scannerRef.current =
                    null;

                mediaStreamRef.current =
                    null;


                setScannerRunning(
                    false
                );


                /*
                 * =================================================
                 * USER-FRIENDLY ERROR
                 * =================================================
                 */

                let message =
                    "Unable to start the camera.";


                const errorName =
                    scannerError?.name ||
                    "";


                const errorMessage =
                    scannerError?.message ||
                    "";


                const lowerMessage =
                    errorMessage.toLowerCase();


                /*
                 * =================================================
                 * PERMISSION ERROR
                 * =================================================
                 */

                if (
                    errorName ===
                    "NotAllowedError" ||
                    lowerMessage.includes(
                        "permission denied"
                    ) ||
                    lowerMessage.includes(
                        "notallowed"
                    )
                ) {

                    message =
                        "Camera permission was denied. Allow camera access for this website in your browser settings, then try again.";

                }


                /*
                 * =================================================
                 * CAMERA BUSY / NOT READABLE
                 * =================================================
                 */

                else if (
                    errorName ===
                    "NotReadableError" ||
                    lowerMessage.includes(
                        "could not start video source"
                    ) ||
                    lowerMessage.includes(
                        "trackstart"
                    )
                ) {

                    message =
                        explicitlyRequestedFacingMode
                            ? (
                                explicitlyRequestedFacingMode ===
                                "user"
                                    ? "The front camera could not be started. Please try again or check that another application is not currently using the camera."
                                    : "The rear camera could not be started. Please try again or check that another application is not currently using the camera."
                            )
                            : "The selected camera could not be started. Please try again or check that another application is not currently using the camera.";

                }


                /*
                 * =================================================
                 * CAMERA NOT FOUND
                 * =================================================
                 */

                else if (
                    errorName ===
                    "NotFoundError" ||
                    lowerMessage.includes(
                        "no camera"
                    )
                ) {

                    message =
                        "No camera was found on this device.";

                }


                /*
                 * =================================================
                 * SECURITY / HTTPS
                 * =================================================
                 */

                else if (
                    errorName ===
                    "SecurityError" ||
                    lowerMessage.includes(
                        "secure context"
                    ) ||
                    lowerMessage.includes(
                        "https"
                    )
                ) {

                    message =
                        "Camera access requires HTTPS. Make sure the production website is running securely over HTTPS.";

                }


                /*
                 * =================================================
                 * INVALID CONSTRAINT
                 * =================================================
                 */

                else if (
                    errorName ===
                    "OverconstrainedError"
                ) {

                    message =
                        explicitlyRequestedFacingMode
                            ? (
                                explicitlyRequestedFacingMode ===
                                "user"
                                    ? "The front camera is not available on this device."
                                    : "The rear camera is not available on this device."
                            )
                            : "The selected camera is unavailable. Choose another camera or press Refresh.";

                }


                /*
                 * =================================================
                 * GENERIC ERROR
                 * =================================================
                 */

                else if (
                    errorMessage
                ) {

                    message =
                        errorMessage;

                }


                setCameraError(
                    message
                );


                /*
                 * =================================================
                 * KEEP EXPLICIT DEVICE SELECTION
                 * =================================================
                 */

                if (
                    explicitlyRequestedCameraId
                ) {

                    selectedCameraRef.current =
                        explicitlyRequestedCameraId;


                    setSelectedCameraId(
                        explicitlyRequestedCameraId
                    );

                }


                /*
                 * =================================================
                 * DEBUG INFORMATION
                 * =================================================
                 */

                console.error(
                    "Camera startup failed:",
                    {
                        name:
                            errorName,

                        message:
                            errorMessage,

                        requestedCamera:
                            explicitlyRequestedCameraId,

                        requestedFacingMode:
                            explicitlyRequestedFacingMode,

                        selectedCamera:
                            cameraId,

                        camerasAvailable:
                            cameras.length,

                        userAgent:
                            navigator.userAgent,
                    }
                );

            } finally {

                /*
                 * =================================================
                 * RELEASE STARTUP LOCK
                 * =================================================
                 */

                startingScannerRef.current =
                    false;

                setInitializingScanner(
                    false
                );

            }

        },
        [
            /*
             * IMPORTANT:
             *
             * activeYear has intentionally been removed.
             *
             * The backend is responsible for determining the
             * active academic year when attendance is processed.
             */

            deviceOnline,
            scannerDevice,
            unlockAudio,
            stopScanner,
            loadCameraList,
            isBackCamera,
            handleQrScan,
        ]
    );





    /* =====================================================
       SWITCH CAMERA
       ===================================================== */

const switchCamera =
    useCallback(
        async (
            cameraId,
            facingMode = null
        ) => {

            if (
                !cameraId &&
                !facingMode
            ) {
                return;
            }

            if (
                startingScannerRef.current
            ) {
                return;
            }

            console.log(
                "Switching camera:",
                {
                    cameraId,
                    facingMode,
                }
            );

            await stopScanner();

            await new Promise(
                resolve =>
                    setTimeout(
                        resolve,
                        250
                    )
            );

            if (
                facingMode === "user" ||
                facingMode === "environment"
            ) {

                selectedFacingModeRef.current =
                    facingMode;

                selectedCameraRef.current =
                    null;

                setSelectedCameraId(
                    null
                );

                await startScanner(
                    null,
                    facingMode
                );

                return;
            }

            selectedFacingModeRef.current =
                null;

            selectedCameraRef.current =
                cameraId;

            setSelectedCameraId(
                cameraId
            );

            await startScanner(
                cameraId,
                null
            );

        },
        [
            stopScanner,
            startScanner,
        ]
    );


    /* =====================================================
       STOP CAMERA BUTTON
       ===================================================== */

    const handleStopScanner =
        useCallback(
            async () => {

                await stopScanner();

                setCameraError(
                    null
                );

            },
            [
                stopScanner,
            ]
        );


    /* =====================================================
       RESTART SCANNER
       ===================================================== */



const restartScanner =
    useCallback(
        async () => {

            setResult(
                INITIAL_RESULT
            );

            setError(
                null
            );

            setCameraError(
                null
            );


            const cameraToRestart =
                selectedCameraRef.current;


            await stopScanner();


            await startScanner(
                cameraToRestart
            );

        },
        [
            stopScanner,
            startScanner,
        ]
    );


    /* =====================================================
       ACTION LABEL
       ===================================================== */

    const getActionLabel =
        () => {

            if (
                result.type === "success" &&
                result.action === "check_in"
            ) {

                return "CHECK-IN SUCCESSFUL";

            }


            if (
                result.type === "success" &&
                result.action === "check_out"
            ) {

                return "CHECK-OUT SUCCESSFUL";

            }


            if (
                result.type === "duplicate"
            ) {

                return "DUPLICATE SCAN";

            }


            if (
                result.type === "error" &&
                result.action === "rejected"
            ) {

                return "SCAN REJECTED";

            }


            return "SCAN RESULT";

        };


    /* =====================================================
       RESULT THEME
       ===================================================== */

    const getResultTheme =
        () => {

            if (
                result.type === "success"
            ) {

                return {

                    background:
                        "#f6ffed",

                    border:
                        "#52c41a",

                    icon:
                        "#52c41a",

                    title:
                        "#237804",

                };

            }


            if (
                result.type === "duplicate"
            ) {

                return {

                    background:
                        "#fff7e6",

                    border:
                        "#fa8c16",

                    icon:
                        "#fa8c16",

                    title:
                        "#ad4e00",

                };

            }


            return {

                background:
                    "#fff1f0",

                border:
                    "#ff4d4f",

                icon:
                    "#ff4d4f",

                title:
                    "#a8071a",

            };

        };


    /* =====================================================
       RENDER SCAN RESULT
       ===================================================== */

    const renderScanResult =
        () => {

            /*
             * KEEP READY TO SCAN SECTION
             */

            if (!result.type) {

                return (

                    <Card
                        bordered={false}
                        className="teacher-scanner-result-card"
                    >

                        <div
                            style={{
                                textAlign:
                                    "center",

                                padding:
                                    "30px 10px",
                            }}
                        >

                            <ScanOutlined
                                style={{
                                    fontSize:
                                        56,

                                    color:
                                        PRIMARY_ORANGE,
                                }}
                            />


                            <Title
                                level={3}
                                style={{
                                    marginTop:
                                        15,

                                    marginBottom:
                                        5,

                                    color:
                                        "#111827",
                                }}
                            >
                                Ready to Scan
                            </Title>


                            <Text
                                type="secondary"
                            >
                                Place the teacher's QR
                                Smart ID Card inside
                                the scanning frame.
                            </Text>

                        </div>

                    </Card>

                );

            }


            const theme =
                getResultTheme();


            const isSuccess =
                result.type ===
                "success";


            const isDuplicate =
                result.type ===
                "duplicate";


            const teacherName =
                getTeacherName(
                    result.teacher
                );


            return (

                <Card
                    bordered={false}
                    style={{
                        borderRadius:
                            16,

                        border:
                            `2px solid ${theme.border}`,

                        background:
                            theme.background,

                        boxShadow:
                            `0 8px 24px ${theme.border}25`,
                    }}
                >

                    <div
                        style={{
                            textAlign:
                                "center",
                        }}
                    >

                        {isSuccess ? (

                            <CheckCircleFilled
                                style={{
                                    fontSize:
                                        68,

                                    color:
                                        theme.icon,
                                }}
                            />

                        ) : isDuplicate ? (

                            <WarningFilled
                                style={{
                                    fontSize:
                                        68,

                                    color:
                                        theme.icon,
                                }}
                            />

                        ) : (

                            <CloseCircleFilled
                                style={{
                                    fontSize:
                                        68,

                                    color:
                                        theme.icon,
                                }}
                            />

                        )}


                        <Title
                            level={2}
                            style={{
                                marginTop:
                                    12,

                                marginBottom:
                                    4,

                                color:
                                    theme.title,

                                fontWeight:
                                    800,
                            }}
                        >
                            {
                                getActionLabel()
                            }
                        </Title>


                        {teacherName && (

                            <Title
                                level={3}
                                style={{
                                    marginTop:
                                        6,

                                    marginBottom:
                                        10,

                                    color:
                                        "#111827",
                                }}
                            >
                                {
                                    teacherName
                                }
                            </Title>

                        )}


                        <Text
                            strong
                            style={{
                                fontSize:
                                    16,

                                display:
                                    "block",

                                color:
                                    "#374151",
                            }}
                        >
                            {
                                result.message
                            }
                        </Text>


                        <Divider />


                        <Row
                            gutter={[
                                12,
                                12,
                            ]}
                        >

                            <Col
                                xs={12}
                                sm={8}
                            >

                                <Text
                                    type="secondary"
                                >
                                    Time
                                </Text>

                                <div>

                                    <Text strong>
                                        {
                                            formatTime(
                                                result.time
                                            )
                                        }
                                    </Text>

                                </div>

                            </Col>


                            <Col
                                xs={12}
                                sm={8}
                            >

                                <Text
                                    type="secondary"
                                >
                                    Gate
                                </Text>

                                <div>

                                    <Text strong>
                                        {
                                            result.gate ||
                                            scannerDevice?.gate_name ||
                                            "--"
                                        }
                                    </Text>

                                </div>

                            </Col>


                            <Col
                                xs={24}
                                sm={8}
                            >

                                <Text
                                    type="secondary"
                                >
                                    Academic Year
                                </Text>

                                <div>

                           <Text strong>
                                {
                                    activeYear?.name ||
                                    "--"
                                }
                            </Text>

                                </div>

                            </Col>

                        </Row>

                    </div>

                </Card>

            );

        };


 


    /* =====================================================
       CAMERA LABEL
       ===================================================== */

    const getSelectedCameraLabel =
        () => {

            const camera =
                cameraList.find(
                    item =>
                        item.deviceId ===
                        selectedCameraId
                );


            if (!camera) {
                return "Camera";
            }


            if (
                isBackCamera(camera)
            ) {

                return "Back Camera";

            }


            if (
                isFrontCamera(camera)
            ) {

                return "Front Camera";

            }


            return camera.label ||
                "Camera";

        };


    /* =====================================================
       MAIN UI
       ===================================================== */

    return (

        <div
            className="teacher-attendance-scanner-page"
            style={{
                minHeight:
                    "100vh",

                background:
                    "#f3f4f6",

                padding:
                    "16px",
            }}
        >

            <div
                style={{
                    maxWidth:
                        1200,

                    margin:
                        "0 auto",
                }}
            >

                {/* =================================================
                    HEADER
                    ================================================= */}

                <Card
                    bordered={false}
                    style={{
                        marginBottom:
                            16,

                        borderRadius:
                            14,
                    }}
                >

                    <Row
                        gutter={[
                            16,
                            16,
                        ]}
                        align="middle"
                        justify="space-between"
                    >

<Col
    xs={24}
    md={14}
>

    <div
        className="teacher-scanner-header"
        style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 20,
        }}
    >

        {/* =====================================================
            COMPANY LOGO
        ===================================================== */}

        <div
            className="teacher-scanner-logo-wrapper"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
            }}
        >

            <img
                src={companyLogo}
                alt="Company Logo"
                className="teacher-scanner-logo"
                style={{
                    width: 190,
                    height: 82,
                    objectFit: "contain",
                    objectPosition: "center",
                    display: "block",
                }}
            />

        </div>


        {/* =====================================================
            SCAN ICON
        ===================================================== */}

        <div
            className="teacher-scanner-icon"
            style={{
                width: 58,
                height: 58,
                borderRadius: 14,
                background: PRIMARY_ORANGE,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow:
                    "0 5px 15px rgba(249, 115, 22, 0.22)",
            }}
        >

            <ScanOutlined
                style={{
                    color: "#fff",
                    fontSize: 31,
                }}
            />

        </div>


        {/* =====================================================
            TITLE
        ===================================================== */}

        <div
            className="teacher-scanner-title"
            style={{
                minWidth: 0,
                flex: 1,
            }}
        >

            <Title
                level={2}
                style={{
                    margin: 0,
                    color: "#111827",
                    fontWeight: 700,
                    lineHeight: 1.2,
                    fontSize: 27,
                }}
            >
                Teacher Smart Attendance
            </Title>


            <Text
                type="secondary"
                style={{
                    display: "block",
                    marginTop: 5,
                    fontSize: 14,
                    lineHeight: 1.5,
                }}
            >
                QR Code Check-In / Check-Out Scanner
            </Text>

        </div>

    </div>


    {/* =========================================================
        RESPONSIVE STYLES
    ========================================================= */}

    <style>
        {`

            /* =================================================
               DESKTOP
            ================================================= */

            .teacher-scanner-header {
                flex-direction: row;
            }


            .teacher-scanner-logo-wrapper {
                width: auto;
            }


            .teacher-scanner-logo {
                width: 190px !important;
                height: 82px !important;
            }


            /* =================================================
               TABLET
            ================================================= */

            @media (max-width: 991px) and (min-width: 768px) {

                .teacher-scanner-header {
                    gap: 15px !important;
                }


                .teacher-scanner-logo {
                    width: 165px !important;
                    height: 75px !important;
                }


                .teacher-scanner-icon {
                    width: 54px !important;
                    height: 54px !important;
                }


                .teacher-scanner-title h2 {
                    font-size: 23px !important;
                }

            }


            /* =================================================
               MOBILE
            ================================================= */

            @media (max-width: 767px) {

                .teacher-scanner-header {
                    flex-direction: column !important;
                    align-items: center !important;
                    justify-content: center !important;
                    gap: 12px !important;
                    width: 100% !important;
                    text-align: center;
                }


                /* ---------------------------------------------
                   FULL-WIDTH LOGO HEADER
                --------------------------------------------- */

                .teacher-scanner-logo-wrapper {
                    width: 100% !important;
                    display: flex !important;
                    justify-content: center !important;
                    align-items: center !important;
                    padding: 4px 8px 8px;
                }


                .teacher-scanner-logo {
                    width: 100% !important;
                    max-width: 420px !important;
                    height: auto !important;
                    max-height: 105px !important;
                    object-fit: contain !important;
                    object-position: center !important;
                }


                /* ---------------------------------------------
                   SCAN ICON
                --------------------------------------------- */

                .teacher-scanner-icon {
                    width: 56px !important;
                    height: 56px !important;
                    border-radius: 14px !important;
                }


                .teacher-scanner-icon .anticon {
                    font-size: 29px !important;
                }


                /* ---------------------------------------------
                   TITLE
                --------------------------------------------- */

                .teacher-scanner-title {
                    width: 100% !important;
                    padding: 0 8px;
                }


                .teacher-scanner-title h2 {
                    font-size: 21px !important;
                    line-height: 1.25 !important;
                    margin-bottom: 0 !important;
                }


                .teacher-scanner-title span {
                    font-size: 13px !important;
                    line-height: 1.5 !important;
                }

            }


            /* =================================================
               SMALL PHONES
            ================================================= */

            @media (max-width: 400px) {

                .teacher-scanner-logo {
                    max-width: 360px !important;
                    max-height: 92px !important;
                }


                .teacher-scanner-icon {
                    width: 52px !important;
                    height: 52px !important;
                }


                .teacher-scanner-title h2 {
                    font-size: 19px !important;
                }


                .teacher-scanner-title span {
                    font-size: 12.5px !important;
                }

            }

        `}
    </style>

</Col>


                        <Col
                            xs={24}
                            md={10}
                        >

                            <Space
                                wrap
                                style={{
                                    width:
                                        "100%",

                                    justifyContent:
                                        "flex-end",
                                }}
                            >

                                <Tag
                                    icon={
                                        <SafetyCertificateOutlined />
                                    }
                                    color="orange"
                                >
                                    {
                                                activeYear?.name || "--"
                                    }
                                </Tag>


                                <Badge
                                    status={
                                        deviceOnline
                                            ? "success"
                                            : "error"
                                    }
                                    text={
                                        deviceOnline
                                            ? "Online"
                                            : "Offline"
                                    }
                                />

                            </Space>

                        </Col>

                    </Row>

                </Card>


                {/* =================================================
                    DEVICE ERROR
                    ================================================= */}

                {deviceError && (

                    <Alert
                        type="warning"
                        showIcon
                        message="Scanner Device Registration"
                        description={

                            <Space
                                direction="vertical"
                                style={{
                                    width:
                                        "100%",
                                }}
                            >

                                <Text>
                                    {
                                        deviceError
                                    }
                                </Text>


                                <Button
                                    icon={
                                        <ReloadOutlined />
                                    }
                                    onClick={
                                        loadScannerDevice
                                    }
                                    loading={
                                        loadingDevice
                                    }
                                >
                                    Refresh Device Registration
                                </Button>

                            </Space>

                        }
                        style={{
                            marginBottom:
                                16,
                        }}
                    />

                )}


                {/* =================================================
                    GENERAL ERROR
                    ================================================= */}

                {error &&
                    !result.type && (

                        <Alert
                            type="error"
                            showIcon
                            closable
                            message={
                                error
                            }
                            style={{
                                marginBottom:
                                    16,
                            }}
                            onClose={() =>
                                setError(null)
                            }
                        />

                    )}


                {/* =================================================
                    CAMERA ERROR
                    ================================================= */}

                {cameraError && (

                    <Alert
                        type="error"
                        showIcon
                        closable
                        message="Camera Error"
                        description={

                            <Space
                                direction="vertical"
                                style={{
                                    width:
                                        "100%",
                                }}
                            >

                                <Text>
                                    {
                                        cameraError
                                    }
                                </Text>


                                {cameraList.length > 0 && (

                                    <Button
                                        icon={
                                            <ReloadOutlined />
                                        }
                                        onClick={
                                            () =>
                                                startScanner(
                                                    selectedCameraId
                                                )
                                        }
                                    >
                                        Try Camera Again
                                    </Button>

                                )}

                            </Space>

                        }
                        style={{
                            marginBottom:
                                16,
                        }}
                        onClose={() =>
                            setCameraError(null)
                        }
                    />

                )}


                {/* =================================================
                    MAIN CONTENT
                    ================================================= */}

                <Row
                    gutter={[
                        16,
                        16,
                    ]}
                >

                    {/* =================================================
                        SCANNER
                        ================================================= */}

                    <Col
                        xs={24}
                        lg={14}
                    >

                        <Card
                            bordered={false}
                            style={{
                                borderRadius:
                                    16,
                            }}
                        >

                            {/* SCANNER HEADER */}

                            <div
                                style={{
                                    display:
                                        "flex",

                                    alignItems:
                                        "center",

                                    justifyContent:
                                        "space-between",

                                    marginBottom:
                                        14,

                                    gap:
                                        10,

                                    flexWrap:
                                        "wrap",
                                }}
                            >

                                <Space>

                                    <CameraOutlined
                                        style={{
                                            color:
                                                PRIMARY_ORANGE,

                                            fontSize:
                                                20,
                                        }}
                                    />

                                    <Text
                                        strong
                                        style={{
                                            fontSize:
                                                17,
                                        }}
                                    >
                                        QR Scanner
                                    </Text>

                                </Space>


                                {scannerRunning ? (

                                    <Tag color="green">
                                        SCANNING
                                    </Tag>

                                ) : (

                                    <Tag>
                                        STOPPED
                                    </Tag>

                                )}

                            </div>


                            {/* =================================================
                                CAMERA SELECTOR
                                ================================================= */}

                            <Card
                                size="small"
                                style={{
                                    marginBottom:
                                        14,

                                    background:
                                        "#fafafa",

                                    borderRadius:
                                        10,
                                }}
                            >

                                <Row
                                    gutter={[
                                        10,
                                        10,
                                    ]}
                                    align="middle"
                                >

                                    <Col
                                        xs={24}
                                        md={14}
                                    >

                                        <Space>

                                            <CameraOutlined />

                                            <Text strong>
                                                Camera
                                            </Text>

                                        </Space>

                                    </Col>


                                    <Col
                                        xs={24}
                                        md={10}
                                    >

                                        <Select
                                            style={{
                                                width:
                                                    "100%",
                                            }}
                                            value={
                                                selectedCameraId ||
                                                undefined
                                            }
                                            placeholder={
                                                cameraList.length
                                                    ? "Select camera"
                                                    : "Detecting cameras..."
                                            }
                                            loading={
                                                initializingScanner &&
                                                cameraList.length === 0
                                            }
                                            disabled={
                                                initializingScanner
                                            }
                                            options={
                                                getCameraOptions(
                                                    cameraList
                                                )
                                            }
                                            onChange={
                                                switchCamera
                                            }
                                            showSearch
                                            optionFilterProp="label"
                                        />

                                    </Col>

                                </Row>


                                <div
                                    style={{
                                        marginTop:
                                            8,
                                    }}
                                >

                                    <Text
                                        type="secondary"
                                        style={{
                                            fontSize:
                                                12,
                                        }}
                                    >
                                        <MobileOutlined />
                                        {" "}
                                        {
                                            getSelectedCameraLabel()
                                        }
                                    </Text>

                                </div>

                            </Card>


                            {/* =================================================
                                QR READER
                                ================================================= */}
<div
    style={{
        width: "100%",
        maxWidth: 520,
        margin: "0 auto",
        position: "relative",
        overflow: "hidden",
        borderRadius: 16,
        background: "#000",
        minHeight: 320,
    }}
>
    {/* =====================================================
        LIVE CAMERA VIDEO
        ===================================================== */}

<video
    ref={videoRef}
    autoPlay
    muted
    playsInline
    style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
        background: "#111827",
    }}
/>


    {/* =====================================================
        SCANNER OVERLAY
        IMPORTANT:
        This does NOT cover the video completely.
        Only the outside area is darkened.
        ===================================================== */}

    {scannerRunning && (

        <div
            style={{
                position: "absolute",
                inset: 0,
                pointerEvents: "none",
                zIndex: 5,
            }}
        >

            {/* =================================================
                TOP DIM AREA
                ================================================= */}

            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "calc(50% - 130px)",
                    background:
                        "rgba(0,0,0,0.48)",
                }}
            />


            {/* =================================================
                BOTTOM DIM AREA
                ================================================= */}

            <div
                style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: "calc(50% - 130px)",
                    background:
                        "rgba(0,0,0,0.48)",
                }}
            />


            {/* =================================================
                LEFT DIM AREA
                ================================================= */}

            <div
                style={{
                    position: "absolute",
                    top: "calc(50% - 130px)",
                    bottom: "calc(50% - 130px)",
                    left: 0,
                    width: "calc(50% - 130px)",
                    background:
                        "rgba(0,0,0,0.48)",
                }}
            />


            {/* =================================================
                RIGHT DIM AREA
                ================================================= */}

            <div
                style={{
                    position: "absolute",
                    top: "calc(50% - 130px)",
                    bottom: "calc(50% - 130px)",
                    right: 0,
                    width: "calc(50% - 130px)",
                    background:
                        "rgba(0,0,0,0.48)",
                }}
            />


            {/* =================================================
                SCAN BOX
                ================================================= */}

            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    width: 260,
                    height: 260,
                    transform:
                        "translate(-50%, -50%)",
                    border:
                        "2px solid rgba(255,255,255,0.35)",
                    borderRadius: 14,
                    boxSizing: "border-box",
                }}
            >

                {/* TOP LEFT */}

                <span
                    style={{
                        position: "absolute",
                        top: -2,
                        left: -2,
                        width: 42,
                        height: 42,
                        borderTop:
                            `4px solid ${PRIMARY_ORANGE}`,
                        borderLeft:
                            `4px solid ${PRIMARY_ORANGE}`,
                        borderRadius: "10px 0 0 0",
                    }}
                />


                {/* TOP RIGHT */}

                <span
                    style={{
                        position: "absolute",
                        top: -2,
                        right: -2,
                        width: 42,
                        height: 42,
                        borderTop:
                            `4px solid ${PRIMARY_ORANGE}`,
                        borderRight:
                            `4px solid ${PRIMARY_ORANGE}`,
                        borderRadius: "0 10px 0 0",
                    }}
                />


                {/* BOTTOM LEFT */}

                <span
                    style={{
                        position: "absolute",
                        bottom: -2,
                        left: -2,
                        width: 42,
                        height: 42,
                        borderBottom:
                            `4px solid ${PRIMARY_ORANGE}`,
                        borderLeft:
                            `4px solid ${PRIMARY_ORANGE}`,
                        borderRadius: "0 0 0 10px",
                    }}
                />


                {/* BOTTOM RIGHT */}

                <span
                    style={{
                        position: "absolute",
                        bottom: -2,
                        right: -2,
                        width: 42,
                        height: 42,
                        borderBottom:
                            `4px solid ${PRIMARY_ORANGE}`,
                        borderRight:
                            `4px solid ${PRIMARY_ORANGE}`,
                        borderRadius: "0 0 10px 0",
                    }}
                />


                {/* =================================================
                    MOVING SCAN LINE
                    ================================================= */}

                <div
                    className="qr-scan-line"
                    style={{
                        position: "absolute",
                        left: 10,
                        right: 10,
                        height: 3,
                        background:
                            PRIMARY_ORANGE,
                        boxShadow:
                            `0 0 10px ${PRIMARY_ORANGE}`,
                        borderRadius: 10,
                    }}
                />

            </div>


            {/* =================================================
                INSTRUCTION
                ================================================= */}

            <div
                style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 18,
                    textAlign: "center",
                    color: "#fff",
                    fontSize: 14,
                    fontWeight: 600,
                    textShadow:
                        "0 1px 4px rgba(0,0,0,0.8)",
                }}
            >
                Point the QR Smart ID Card inside the box
            </div>

        </div>
    )}


    {/* =====================================================
        CAMERA READY MESSAGE
        ===================================================== */}

    {!scannerRunning &&
        !initializingScanner && (

            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    background:
                        "rgba(17,24,39,0.95)",
                    color: "#fff",
                    zIndex: 10,
                }}
            >

                <CameraOutlined
                    style={{
                        fontSize: 56,
                        color: PRIMARY_ORANGE,
                        marginBottom: 15,
                    }}
                />

                <Title
                    level={3}
                    style={{
                        color: "#fff",
                        margin: 0,
                    }}
                >
                    Camera Ready
                </Title>

                <Text
                    style={{
                        color: "#d1d5db",
                        marginTop: 8,
                    }}
                >
                    Start the scanner to activate
                    the camera.
                </Text>

            </div>

        )}


    {/* =====================================================
        INITIALIZING
        ===================================================== */}

    {initializingScanner && (

        <div
            style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background:
                    "rgba(17,24,39,0.90)",
                zIndex: 20,
            }}
        >

            <Space
                direction="vertical"
                align="center"
            >

                <Spin size="large" />

                <Text
                    style={{
                        color: "#fff",
                    }}
                >
                    Starting camera...
                </Text>

            </Space>

        </div>

    )}

</div>

                            {/* =================================================
                                CAMERA INFORMATION
                                ================================================= */}

                            <div
                                style={{
                                    marginTop:
                                        12,

                                    textAlign:
                                        "center",
                                }}
                            >

                                <Space
                                    wrap
                                    justify="center"
                                >

                                    <Tag
                                        icon={
                                            <CameraOutlined />
                                        }
                                        color={
                                            cameraList.length
                                                ? "green"
                                                : "default"
                                        }
                                    >
                                        {
                                            cameraList.length
                                        }{" "}
                                        Camera
                                        {
                                            cameraList.length === 1
                                                ? ""
                                                : "s"
                                        }
                                    </Tag>


                                    {cameraPermissionGranted && (

                                        <Tag
                                            icon={
                                                <SafetyCertificateOutlined />
                                            }
                                            color="green"
                                        >
                                            Camera Permission
                                            Granted
                                        </Tag>

                                    )}

                                </Space>

                            </div>


                            {/* =================================================
                                CONTROLS
                                ================================================= */}

                            <div
                                style={{
                                    marginTop:
                                        18,

                                    display:
                                        "flex",

                                    justifyContent:
                                        "center",

                                    gap:
                                        10,

                                    flexWrap:
                                        "wrap",
                                }}
                            >

                                {!scannerRunning ? (

                                    <Button
                                        type="primary"
                                        size="large"
                                        icon={
                                            <CameraOutlined />
                                        }
                                        loading={
                                            initializingScanner
                                        }
                                        disabled={
                                            !deviceOnline ||
                                            loadingDevice ||
                                            !scannerDevice ||
                                            scannerDevice.is_active === false
                                        }
                                        onClick={
                                            () =>
                                                startScanner()
                                        }
                                        style={{
                                            background:
                                                PRIMARY_ORANGE,

                                            borderColor:
                                                PRIMARY_ORANGE,

                                            height:
                                                48,

                                            minWidth:
                                                220,

                                            fontWeight:
                                                600,
                                        }}
                                    >
                                        {
                                            loadingDevice
                                                ? "Loading Device..."
                                                : "Start Scanner"
                                        }
                                    </Button>

                                ) : (

                                    <Button
                                        danger
                                        size="large"
                                        icon={
                                            <CloseCircleFilled />
                                        }
                                        onClick={
                                            handleStopScanner
                                        }
                                        style={{
                                            height:
                                                48,

                                            minWidth:
                                                220,

                                            fontWeight:
                                                600,
                                        }}
                                    >
                                        Stop Scanner
                                    </Button>

                                )}


{scannerRunning && (
    <Button
        size="large"
        icon={
            <SwapOutlined />
        }
        onClick={async () => {

            const currentFacingMode =
                selectedFacingModeRef.current ||
                "environment";

            const nextFacingMode =
                currentFacingMode === "environment"
                    ? "user"
                    : "environment";

            await switchCamera(
                null,
                nextFacingMode
            );

        }}
    >
        Switch Camera
    </Button>
)}


                                <Button
                                    size="large"
                                    icon={
                                        <ReloadOutlined />
                                    }
                                    onClick={
                                        async () => {

                                            await stopScanner();

                                            await loadScannerDevice();

                                            await loadCameraList();

                                        }
                                    }
                                    loading={
                                        loadingDevice
                                    }
                                >
                                    Refresh
                                </Button>

                            </div>


                            {/* =================================================
                                RESTART
                                ================================================= */}

                            {scannerRunning && (

                                <div
                                    style={{
                                        marginTop:
                                            10,

                                        textAlign:
                                            "center",
                                    }}
                                >

                                    <Button
                                        type="link"
                                        icon={
                                            <ReloadOutlined />
                                        }
                                        onClick={
                                            restartScanner
                                        }
                                    >
                                        Restart Camera
                                    </Button>

                                </div>

                            )}


                            <div
                                style={{
                                    marginTop:
                                        12,

                                    textAlign:
                                        "center",
                                }}
                            >

                                <Text
                                    type="secondary"
                                >
                                    Point the camera at the
                                    teacher's QR Smart ID
                                    Card.
                                </Text>

                            </div>

                        </Card>

                    </Col>


                    {/* =================================================
                        RESULT
                        ================================================= */}

                    <Col
                        xs={24}
                        lg={10}
                    >

                        {renderScanResult()}


                        {/* =================================================
                            SCANNER INFORMATION
                            ================================================= */}

                        <Card
                            bordered={false}
                            style={{
                                marginTop:
                                    16,

                                borderRadius:
                                    16,
                            }}
                        >

                            <Title
                                level={4}
                                style={{
                                    marginTop:
                                        0,
                                }}
                            >
                                Scanner Information
                            </Title>


                            <Space
                                direction="vertical"
                                style={{
                                    width:
                                        "100%",
                                }}
                                size={12}
                            >

                                <Row
                                    justify="space-between"
                                    align="middle"
                                >

                                    <Space>

                                        <DesktopOutlined />

                                        <Text
                                            type="secondary"
                                        >
                                            Scanner Device
                                        </Text>

                                    </Space>


                                    {loadingDevice ? (

                                        <Spin
                                            size="small"
                                        />

                                    ) : scannerDevice ? (

                                        <Tag
                                            color={
                                                scannerDevice.is_active === false
                                                    ? "red"
                                                    : "green"
                                            }
                                        >
                                            {
                                                scannerDevice.is_active === false
                                                    ? "INACTIVE"
                                                    : "REGISTERED"
                                            }
                                        </Tag>

                                    ) : (

                                        <Tag color="red">
                                            NOT REGISTERED
                                        </Tag>

                                    )}

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Device Name
                                    </Text>

                                    <Text strong>
                                        {
                                            scannerDevice?.device_name ||
                                            "--"
                                        }
                                    </Text>

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Device ID
                                    </Text>

                                    <Text
                                        strong
                                        style={{
                                            maxWidth:
                                                220,

                                            textAlign:
                                                "right",

                                            wordBreak:
                                                "break-word",
                                        }}
                                    >
                                        {
                                            scannerDevice?.device_id ||
                                            "--"
                                        }
                                    </Text>

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Gate
                                    </Text>

                                    <Text strong>
                                        {
                                            scannerDevice?.gate_name ||
                                            "--"
                                        }
                                    </Text>

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Location
                                    </Text>

                                    <Text
                                        strong
                                        style={{
                                            maxWidth:
                                                220,

                                            textAlign:
                                                "right",
                                        }}
                                    >
                                        {
                                            scannerDevice?.location_description ||
                                            "--"
                                        }
                                    </Text>

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Academic Year
                                    </Text>

<Text strong>
    {
        activeYear?.name ||
        "--"
    }
</Text>

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Network
                                    </Text>

                                    <Badge
                                        status={
                                            deviceOnline
                                                ? "success"
                                                : "error"
                                        }
                                        text={
                                            deviceOnline
                                                ? "Connected"
                                                : "Offline"
                                        }
                                    />

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Camera
                                    </Text>

                                    <Text strong>
                                        {
                                            getSelectedCameraLabel()
                                        }
                                    </Text>

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Last Server Seen
                                    </Text>

                                    <Text strong>
                                        {
                                            scannerDevice?.last_seen
                                                ? formatTime(
                                                    scannerDevice.last_seen
                                                )
                                                : "--"
                                        }
                                    </Text>

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Last Scan
                                    </Text>

                                    <Text strong>
                                        {
                                            lastScanAt
                                                ? formatTime(
                                                    lastScanAt
                                                )
                                                : scannerDevice?.last_scan_at
                                                    ? formatTime(
                                                        scannerDevice.last_scan_at
                                                    )
                                                    : "--"
                                        }
                                    </Text>

                                </Row>


                                <Row justify="space-between">

                                    <Text type="secondary">
                                        Total Server Scans
                                    </Text>

                                    <Text strong>
                                        {
                                            scannerDevice?.total_scans ??
                                            0
                                        }
                                    </Text>

                                </Row>

                            </Space>

                        </Card>

                    </Col>

                </Row>


                {/* =================================================
                    STATISTICS
                    ================================================= */}

                <Row
                    gutter={[
                        16,
                        16,
                    ]}
                    style={{
                        marginTop:
                            16,
                    }}
                >

                    <Col
                        xs={24}
                        sm={8}
                    >

                        <Card
                            bordered={false}
                            style={{
                                borderRadius:
                                    14,
                            }}
                        >

                            <Statistic
                                title="Successful Scans"
                                value={
                                    scanCount
                                }
                                prefix={
                                    <CheckCircleFilled
                                        style={{
                                            color:
                                                SWEET_SUCCESS,
                                        }}
                                    />
                                }
                            />

                        </Card>

                    </Col>


                    <Col
                        xs={24}
                        sm={8}
                    >

                        <Card
                            bordered={false}
                            style={{
                                borderRadius:
                                    14,
                            }}
                        >

                            <Statistic
                                title="Duplicate Scans"
                                value={
                                    duplicateCount
                                }
                                prefix={
                                    <WarningFilled
                                        style={{
                                            color:
                                                SWEET_WARNING,
                                        }}
                                    />
                                }
                            />

                        </Card>

                    </Col>


                    <Col
                        xs={24}
                        sm={8}
                    >

                        <Card
                            bordered={false}
                            style={{
                                borderRadius:
                                    14,
                            }}
                        >

                            <Statistic
                                title="Rejected Scans"
                                value={
                                    rejectedCount
                                }
                                prefix={
                                    <CloseCircleFilled
                                        style={{
                                            color:
                                                SWEET_ERROR,
                                        }}
                                    />
                                }
                            />

                        </Card>

                    </Col>

                </Row>


                {/* =================================================
                    AUDIO STATUS
                    ================================================= */}

                <Card
                    bordered={false}
                    style={{
                        marginTop:
                            16,

                        borderRadius:
                            14,
                    }}
                >

                    <Row
                        gutter={[
                            16,
                            16,
                        ]}
                        align="middle"
                    >

                        <Col
                            xs={24}
                            md={12}
                        >

                            <Space>

                                <SoundOutlined
                                    style={{
                                        color:
                                            PRIMARY_ORANGE,
                                    }}
                                />

                                <Text strong>
                                    Scan Audio
                                </Text>

                                <Tag
                                    color={
                                        audioUnlockedRef.current
                                            ? "green"
                                            : "orange"
                                    }
                                >
                                    {
                                        audioUnlockedRef.current
                                            ? "READY"
                                            : "ACTIVATES WITH SCANNER"
                                    }
                                </Tag>

                            </Space>

                        </Col>


                        <Col
                            xs={24}
                            md={12}
                        >

                            <Text
                                type="secondary"
                            >
                                Success and error sounds
                                play automatically after
                                the QR response is received.
                            </Text>

                        </Col>

                    </Row>

                </Card>


                {/* =================================================
                    SCAN STATUS BAR
                    ================================================= */}

                <Card
                    bordered={false}
                    style={{
                        marginTop:
                            16,

                        borderRadius:
                            14,
                    }}
                >

                    <Row
                        gutter={[
                            16,
                            16,
                        ]}
                        align="middle"
                    >

                        <Col
                            xs={24}
                            md={12}
                        >

                            <Space>

                                <Badge
                                    status={
                                        scannerRunning
                                            ? "success"
                                            : "default"
                                    }
                                />

                                <Text strong>
                                    Scanner Status:
                                </Text>

                                <Tag
                                    color={
                                        scannerRunning
                                            ? "green"
                                            : "default"
                                    }
                                >
                                    {
                                        scannerRunning
                                            ? "READY FOR SCANNING"
                                            : "STOPPED"
                                    }
                                </Tag>

                            </Space>

                        </Col>


                        <Col
                            xs={24}
                            md={12}
                        >

                            <div
                                style={{
                                    textAlign:
                                        "right",
                                }}
                            >

                                <Text
                                    type="secondary"
                                >
                                    Last scan:
                                </Text>

                                {" "}

                                <Text strong>
                                    {
                                        lastScanAt
                                            ? formatTime(
                                                lastScanAt
                                            )
                                            : "--"
                                    }
                                </Text>

                            </div>

                        </Col>

                    </Row>

                </Card>


                {/* =================================================
                    FOOTER
                    ================================================= */}

                <div
                    style={{
                        textAlign:
                            "center",

                        padding:
                            "20px 10px",
                    }}
                >

                    <Space
                        wrap
                        align="center"
                    >

                        <Text type="secondary">
                            <SafetyCertificateOutlined />
                            {" "}
                            Secure QR Attendance
                        </Text>


                        <Text type="secondary">
                            •
                        </Text>


                        <Text type="secondary">
                            <WifiOutlined />
                            {" "}
                            Server Registered Device
                        </Text>


                        <Text type="secondary">
                            •
                        </Text>


                        <Text type="secondary">
                            <CameraOutlined />
                            {" "}
                            Multi-Camera Support
                        </Text>


                        <Text type="secondary">
                            •
                        </Text>


                

                    </Space>

                </div>

            </div>


            {/* =====================================================
                CSS
                ===================================================== */}

           <style>
{`

.teacher-attendance-scanner-page {
    color: #111827;
}




.teacher-attendance-scanner-page
.ant-card {
    box-shadow:
        0 2px 8px
        rgba(0, 0, 0, 0.06);
}

.teacher-scanner-result-card {
    border-radius: 16px;
}

#${QR_READER_ID} {
    width: 100% !important;
    display: block;
    background: #111827;
    object-fit: cover;
}

#${QR_READER_ID}::-webkit-media-controls {
    display: none !important;
}

@media (max-width: 576px) {

    .teacher-attendance-scanner-page {
        padding: 8px !important;
    }

    .teacher-attendance-scanner-page
    .ant-card-body {
        padding: 12px !important;
    }

    .teacher-attendance-scanner-page
    h2.ant-typography {
        font-size: 22px !important;
    }

    .teacher-attendance-scanner-page
    h3.ant-typography {
        font-size: 20px !important;
    }

    #${QR_READER_ID} {
        min-height: 280px;
        height: 280px;
        object-fit: cover !important;
    }

    .swal2-popup {
        width:
            calc(100% - 24px) !important;
    }

}

.swal2-popup {
    border-radius:
        18px !important;
}

.swal2-title {
    font-weight:
        800 !important;
}

.swal2-confirm {
    border-radius:
        8px !important;

    font-weight:
        700 !important;
}

.qr-scan-line {
    position: absolute;

    left: 10px;
    right: 10px;

    top: 10px;

    height: 3px;

    background: #f97316;

    border-radius: 999px;

    box-shadow:
        0 0 4px #fff,
        0 0 8px #f97316,
        0 0 16px #f97316,
        0 0 28px rgba(249, 115, 22, 0.8);

    animation:
        qrScanAnimation 2s
        cubic-bezier(0.45, 0, 0.55, 1)
        infinite alternate;

    will-change: transform;

    z-index: 20;
}


@keyframes qrScanAnimation {

    0% {
        transform: translateY(0);
        opacity: 0.55;
    }

    50% {
        opacity: 1;
    }

    100% {
        transform: translateY(237px);
        opacity: 0.55;
    }

}

`}

</style>

        </div>

    );

};


export default TeacherAttendanceScanner;



